//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IClient {
    /**
     * @return Success
     */
    retrieveAllBookings(): Observable<ServiceDataPaginationDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllBookingsPaginated(body: PaginationArgs | undefined): Observable<ServiceDataPaginationDataAdministrationResult>;
    /**
     * @param bookingId (optional) 
     * @return Success
     */
    retrieveBookingInfoById(bookingId: number | undefined): Observable<BookingDataAdministrationResult>;
    /**
     * @param bookingId (optional) 
     * @return Success
     */
    retrieveBookingById(bookingId: number | undefined): Observable<BookingDataAdministrationResult>;
    /**
     * @param token (optional) 
     * @return Success
     */
    retrieveBookingByBookingToken(token: string | undefined): Observable<BookingDataAdministrationResult>;
    /**
     * @param userId (optional) 
     * @return Success
     */
    retrieveBookingsByUserId(userId: number | undefined): Observable<BookingDataAdministrationResult>;
    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    retrieveBookingsByUserIdPaginated(userId: number | undefined, body: PaginationArgs | undefined): Observable<BookingDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addBooking(body: AddBookingData | undefined): Observable<BookingDataAdministrationResult>;
    /**
     * @param bookingId (optional) 
     * @return Success
     */
    cancelBooking(bookingId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addConfiguration(body: AddConfigurationData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateConfiguration(body: UpdateConfigurationData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingHoursDailyConfig(body: WorkingHoursDailyConfigData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllWorkingHoursDailyConfigs(body: AddWorkingHoursDailyConfigs | undefined): Observable<AdministrationResultStatus>;
    /**
     * @return Success
     */
    retrieveActiveConfigurationParameter(): Observable<ConfigurationParameterDataAdministrationResult>;
    /**
     * @return Success
     */
    retrieveAllDays(): Observable<DayDataListAdministrationResult>;
    /**
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveEmployeesByServiceId(serviceId: number | undefined): Observable<EmployeeDataPaginationDataAdministrationResult>;
    /**
     * @param serviceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    retrieveEmployeesByServiceIdPaginated(serviceId: number | undefined, body: PaginationArgs | undefined): Observable<EmployeeDataPaginationDataAdministrationResult>;
    /**
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveAnyAvailableEmployeeByServiceId(serviceId: number | undefined): Observable<EmployeeDataAdministrationResult>;
    /**
     * @param employeeId (optional) 
     * @return Success
     */
    retrieveEmployeeById(employeeId: number | undefined): Observable<EmployeeDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllHolidays(body: PaginationArgs | undefined): Observable<HolidayDataPaginationDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addHoliday(body: HolidayData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editHoliday(body: HolidayData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param holidayId (optional) 
     * @return Success
     */
    retriveHolidayById(holidayId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param holidayId (optional) 
     * @return Success
     */
    deleteHoliday(holidayId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllMemberships(body: PaginationArgs | undefined): Observable<MembershipDataPaginationDataAdministrationResult>;
    /**
     * @param membershipId (optional) 
     * @return Success
     */
    retrieveMembershipById(membershipId: number | undefined): Observable<MembershipDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editMembership(body: MembershipData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addMembership(body: MembershipData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllMembershipTypes(body: PaginationArgs | undefined): Observable<MembershipTypeDataPaginationDataAdministrationResult>;
    /**
     * @param membershipTypeId (optional) 
     * @return Success
     */
    retrieveMembershipTypeById(membershipTypeId: number | undefined): Observable<MembershipTypeDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editMembershipType(body: MembershipTypeData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addMembershipType(body: MembershipTypeData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    replaceEmployeeWithAddingPriorityWDC(body: ReplaceEmployeeData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param removeExist (optional) 
     * @param body (optional) 
     * @return Success
     */
    addPriorityWorkDayConfigs(removeExist: boolean | undefined, body: AddPriorityWorkDayConfigs | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param employeeProfileId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addPriorityWorkDayConfig(employeeProfileId: number | undefined, body: AddPriorityWorkDayConfig | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updatePriorityWorkDayConfig(body: PriorityWorkDayConfigData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @return Success
     */
    retrieveAllPriorityWorkDayConfigs(): Observable<PriorityWorkDayConfigDataListAdministrationResult>;
    /**
     * @param removeExist (optional) 
     * @param body (optional) 
     * @return Success
     */
    removeScheduleForDayByAddingPriorityWDC(removeExist: boolean | undefined, body: AddPriorityWorkDayConfigs | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addSchedule(body: AddScheduleData[] | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateScheduleRange(body: UpdateScheduleData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param scheduleId (optional) 
     * @return Success
     */
    deactivateSchedule(scheduleId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param employeeId (optional) 
     * @return Success
     */
    deactivateSchedulesByEmployeeId(employeeId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param scheduleId (optional) 
     * @return Success
     */
    retrieveScheduleById(scheduleId: number | undefined): Observable<ScheduleDataAdministrationResult>;
    /**
     * @param employeeProfileId (optional) 
     * @return Success
     */
    retrieveAllSchedules(employeeProfileId: number | undefined): Observable<ScheduleDataListAdministrationResult>;
    /**
     * @param employeeProfileId (optional) 
     * @return Success
     */
    retrieveAllActiveUnpassedEmployeeSchedulesBasic(employeeProfileId: number | undefined): Observable<ScheduleDataListAdministrationResult>;
    /**
     * @param employeeId (optional) 
     * @return Success
     */
    retrieveSchedulesByEmployeeId(employeeId: number | undefined): Observable<ScheduleDataListAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateNegatedSchedulesByWorkingHoursDailyConfigsChange(body: AddWorkingHoursDailyConfigs | undefined): Observable<ScheduleDataListAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrievePeriodicScheduleEntries(body: PeriodicScheduleGroupsAvailabilityArgs | undefined): Observable<PeriodicScheduleEntriesResultDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAvailability(body: DailyAvailabilityArgs | undefined): Observable<DateTimeAvailabilityDataDictionaryAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServices(body: PaginationArgs | undefined): Observable<ServiceDataPaginationDataAdministrationResult>;
    /**
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveServiceById(serviceId: number | undefined): Observable<ServiceDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editService(body: ServiceData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addService(body: ServiceData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param serviceId (optional) 
     * @return Success
     */
    deactivateService(serviceId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param serviceId (optional) 
     * @return Success
     */
    activateService(serviceId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param serviceId (optional) 
     * @return Success
     */
    removeService(serviceId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @return Success
     */
    retrieveAllServiceCategories(): Observable<ServiceCategoryDataPaginationDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServiceCategoriesPaginated(body: PaginationArgs | undefined): Observable<ServiceCategoryDataPaginationDataAdministrationResult>;
    /**
     * @param serviceCategoryId (optional) 
     * @return Success
     */
    retrieveServiceCategoryById(serviceCategoryId: number | undefined): Observable<ServiceCategoryDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editServiceCategory(body: ServiceCategoryData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceCategory(body: ServiceCategoryData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param serviceCategoryId (optional) 
     * @return Success
     */
    deactivateServiceCategory(serviceCategoryId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServiceDiscounts(body: PaginationArgs | undefined): Observable<ServiceDiscountDataPaginationDataAdministrationResult>;
    /**
     * @param serviceDiscountId (optional) 
     * @return Success
     */
    retrieveServiceDiscountById(serviceDiscountId: number | undefined): Observable<ServiceDiscountDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editServiceDiscount(body: ServiceDiscountData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceDiscount(body: ServiceDiscountData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param serviceDiscountId (optional) 
     * @return Success
     */
    deleteServiceDiscount(serviceDiscountId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServiceTypes(body: PaginationArgs | undefined): Observable<ServiceTypeDataPaginationDataAdministrationResult>;
    /**
     * @param serviceTypeId (optional) 
     * @return Success
     */
    retrieveServiceTypeById(serviceTypeId: number | undefined): Observable<ServiceTypeDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editServiceType(body: ServiceTypeData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceType(body: ServiceTypeData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param serviceTypeId (optional) 
     * @return Success
     */
    deleteServiceType(serviceTypeId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @return Success
     */
    retrieveAllShiftTemplates(): Observable<ShiftTemplateDataListAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addShiftTemplate(body: AddShiftTemplateData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateShiftTemplate(body: UpdateShiftTemplateData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param shiftTemplateId (optional) 
     * @return Success
     */
    retrieveShiftTemplateById(shiftTemplateId: number | undefined): Observable<ShiftTemplateDataAdministrationResult>;
    /**
     * @param shiftTemplateId (optional) 
     * @return Success
     */
    deleteShiftTemplate(shiftTemplateId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllTerms(body: PaginationArgs | undefined): Observable<TermDataPaginationDataAdministrationResult>;
    /**
     * @param termId (optional) 
     * @return Success
     */
    retrieveTermById(termId: number | undefined): Observable<TermDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveTermsByTermSearchArgs(body: TermSearchArgs | undefined): Observable<TermDataListAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editTerm(body: TermData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param termId (optional) 
     * @return Success
     */
    cancelTerm(termId: number | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveGeneratedTimeSlots(body: RetrieveGeneratedTimeSlotsData | undefined): Observable<TermDataListAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    generateAlternativeTimeSlots(body: TermData | undefined): Observable<TermDataListAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveNegatedTermsByWorkingHoursDailyConfigs(body: AddWorkingHoursDailyConfigs | undefined): Observable<TermDataListAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveNegatedTermsByServiceRemoval(body: ServiceData[] | undefined): Observable<TermDataListAdministrationResult>;
    /**
     * @param key (optional) 
     * @param code (optional) 
     * @return Success
     */
    verifyEmail(key: number | undefined, code: string | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginRequestData | undefined): Observable<LoginUserDataSecurityResult>;
    /**
     * @return Success
     */
    signout(): Observable<SecurityResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordRequestData | undefined): Observable<SecurityResultStatus>;
    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    changePasswordForUser(userId: number | undefined, body: ChangePasswordForUserRequestData | undefined): Observable<SecurityResultStatus>;
    /**
     * @param userId (optional) 
     * @return Success
     */
    retrieveUserDetail(userId: number | undefined): Observable<UserRoleDataAdministrationResult>;
    /**
     * @param emailOrPhoneNumber (optional) 
     * @return Success
     */
    generateResetPasswordCode(emailOrPhoneNumber: string | undefined): Observable<Int32SecurityResult>;
    /**
     * @param key (optional) 
     * @param resertPasswordCode (optional) 
     * @param newPassword (optional) 
     * @return Success
     */
    resetPasswordWithCode(key: number | undefined, resertPasswordCode: string | undefined, newPassword: string | undefined): Observable<SecurityResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editUser(body: UserProfileData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addUser(body: UserProfileData | undefined): Observable<AdministrationResultStatus>;
    /**
     * @param isEmployee (optional) 
     * @param body (optional) 
     * @return Success
     */
    retrieveAllUsersPaginated(isEmployee: boolean | undefined, body: PaginationArgs | undefined): Observable<UserProfileDataPaginationDataAdministrationResult>;
    /**
     * @param roleId (optional) 
     * @param date (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveAllUsers(roleId: number | undefined, date: Date | undefined, serviceId: number | undefined): Observable<UserProfileDataPaginationDataAdministrationResult>;
    /**
     * @param userId (optional) 
     * @return Success
     */
    retrieveUserById(userId: number | undefined): Observable<UserProfileDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllEmployeesWithServices(body: PaginationArgs | undefined): Observable<UserProfileDataPaginationDataAdministrationResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllProfilesFromClients(body: PaginationArgs | undefined): Observable<UserProfileDataPaginationDataAdministrationResult>;
    /**
     * @return Success
     */
    retrieveAllUserRoles(): Observable<UserRoleDataListAdministrationResult>;
}

@Injectable()
export class Client implements IClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    retrieveAllBookings(): Observable<ServiceDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/RetrieveAllBookings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllBookings(response: HttpResponseBase): Observable<ServiceDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllBookingsPaginated(body: PaginationArgs | undefined): Observable<ServiceDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/RetrieveAllBookingsPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllBookingsPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllBookingsPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllBookingsPaginated(response: HttpResponseBase): Observable<ServiceDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    retrieveBookingInfoById(bookingId: number | undefined): Observable<BookingDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/RetrieveBookingInfoById?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBookingInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBookingInfoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDataAdministrationResult>;
        }));
    }

    protected processRetrieveBookingInfoById(response: HttpResponseBase): Observable<BookingDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    retrieveBookingById(bookingId: number | undefined): Observable<BookingDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/RetrieveBookingById?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBookingById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBookingById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDataAdministrationResult>;
        }));
    }

    protected processRetrieveBookingById(response: HttpResponseBase): Observable<BookingDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    retrieveBookingByBookingToken(token: string | undefined): Observable<BookingDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/RetrieveBookingByBookingToken?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBookingByBookingToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBookingByBookingToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDataAdministrationResult>;
        }));
    }

    protected processRetrieveBookingByBookingToken(response: HttpResponseBase): Observable<BookingDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    retrieveBookingsByUserId(userId: number | undefined): Observable<BookingDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/RetrieveBookingsByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBookingsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBookingsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDataAdministrationResult>;
        }));
    }

    protected processRetrieveBookingsByUserId(response: HttpResponseBase): Observable<BookingDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    retrieveBookingsByUserIdPaginated(userId: number | undefined, body: PaginationArgs | undefined): Observable<BookingDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/RetrieveBookingsByUserIdPaginated?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBookingsByUserIdPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBookingsByUserIdPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDataAdministrationResult>;
        }));
    }

    protected processRetrieveBookingsByUserIdPaginated(response: HttpResponseBase): Observable<BookingDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addBooking(body: AddBookingData | undefined): Observable<BookingDataAdministrationResult> {
        let url_ = this.baseUrl + "/Booking/AddBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDataAdministrationResult>;
        }));
    }

    protected processAddBooking(response: HttpResponseBase): Observable<BookingDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    cancelBooking(bookingId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/Booking/CancelBooking?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processCancelBooking(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addConfiguration(body: AddConfigurationData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ConfigurationParameter/AddConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddConfiguration(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateConfiguration(body: UpdateConfigurationData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ConfigurationParameter/UpdateConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processUpdateConfiguration(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingHoursDailyConfig(body: WorkingHoursDailyConfigData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ConfigurationParameter/UpdateWorkingHoursDailyConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkingHoursDailyConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkingHoursDailyConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processUpdateWorkingHoursDailyConfig(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllWorkingHoursDailyConfigs(body: AddWorkingHoursDailyConfigs | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ConfigurationParameter/UpdateAllWorkingHoursDailyConfigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllWorkingHoursDailyConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllWorkingHoursDailyConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processUpdateAllWorkingHoursDailyConfigs(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    retrieveActiveConfigurationParameter(): Observable<ConfigurationParameterDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ConfigurationParameter/RetrieveActiveConfigurationParameter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveActiveConfigurationParameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveActiveConfigurationParameter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationParameterDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationParameterDataAdministrationResult>;
        }));
    }

    protected processRetrieveActiveConfigurationParameter(response: HttpResponseBase): Observable<ConfigurationParameterDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationParameterDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    retrieveAllDays(): Observable<DayDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Day/RetrieveAllDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DayDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DayDataListAdministrationResult>;
        }));
    }

    protected processRetrieveAllDays(response: HttpResponseBase): Observable<DayDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DayDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveEmployeesByServiceId(serviceId: number | undefined): Observable<EmployeeDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/Employee/RetrieveEmployeesByServiceId?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveEmployeesByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveEmployeesByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveEmployeesByServiceId(response: HttpResponseBase): Observable<EmployeeDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    retrieveEmployeesByServiceIdPaginated(serviceId: number | undefined, body: PaginationArgs | undefined): Observable<EmployeeDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/Employee/RetrieveEmployeesByServiceIdPaginated?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveEmployeesByServiceIdPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveEmployeesByServiceIdPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveEmployeesByServiceIdPaginated(response: HttpResponseBase): Observable<EmployeeDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveAnyAvailableEmployeeByServiceId(serviceId: number | undefined): Observable<EmployeeDataAdministrationResult> {
        let url_ = this.baseUrl + "/Employee/RetrieveAnyAvailableEmployeeByServiceId?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAnyAvailableEmployeeByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAnyAvailableEmployeeByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDataAdministrationResult>;
        }));
    }

    protected processRetrieveAnyAvailableEmployeeByServiceId(response: HttpResponseBase): Observable<EmployeeDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    retrieveEmployeeById(employeeId: number | undefined): Observable<EmployeeDataAdministrationResult> {
        let url_ = this.baseUrl + "/Employee/RetrieveEmployeeById?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveEmployeeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveEmployeeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDataAdministrationResult>;
        }));
    }

    protected processRetrieveEmployeeById(response: HttpResponseBase): Observable<EmployeeDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllHolidays(body: PaginationArgs | undefined): Observable<HolidayDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Holiday/RetrieveAllHolidays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllHolidays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllHolidays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllHolidays(response: HttpResponseBase): Observable<HolidayDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HolidayDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addHoliday(body: HolidayData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Holiday/AddHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddHoliday(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editHoliday(body: HolidayData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Holiday/EditHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditHoliday(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param holidayId (optional) 
     * @return Success
     */
    retriveHolidayById(holidayId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Holiday/RetriveHolidayById?";
        if (holidayId === null)
            throw new Error("The parameter 'holidayId' cannot be null.");
        else if (holidayId !== undefined)
            url_ += "holidayId=" + encodeURIComponent("" + holidayId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetriveHolidayById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetriveHolidayById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processRetriveHolidayById(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param holidayId (optional) 
     * @return Success
     */
    deleteHoliday(holidayId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Holiday/DeleteHoliday?";
        if (holidayId === null)
            throw new Error("The parameter 'holidayId' cannot be null.");
        else if (holidayId !== undefined)
            url_ += "holidayId=" + encodeURIComponent("" + holidayId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeleteHoliday(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllMemberships(body: PaginationArgs | undefined): Observable<MembershipDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Membership/RetrieveAllMemberships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllMemberships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllMemberships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllMemberships(response: HttpResponseBase): Observable<MembershipDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param membershipId (optional) 
     * @return Success
     */
    retrieveMembershipById(membershipId: number | undefined): Observable<MembershipDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Membership/RetrieveMembershipById?";
        if (membershipId === null)
            throw new Error("The parameter 'membershipId' cannot be null.");
        else if (membershipId !== undefined)
            url_ += "membershipId=" + encodeURIComponent("" + membershipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveMembershipById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveMembershipById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipDataAdministrationResult>;
        }));
    }

    protected processRetrieveMembershipById(response: HttpResponseBase): Observable<MembershipDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editMembership(body: MembershipData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Membership/EditMembership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditMembership(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMembership(body: MembershipData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Membership/AddMembership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddMembership(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllMembershipTypes(body: PaginationArgs | undefined): Observable<MembershipTypeDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/MembershipType/RetrieveAllMembershipTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllMembershipTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllMembershipTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipTypeDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipTypeDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllMembershipTypes(response: HttpResponseBase): Observable<MembershipTypeDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipTypeDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param membershipTypeId (optional) 
     * @return Success
     */
    retrieveMembershipTypeById(membershipTypeId: number | undefined): Observable<MembershipTypeDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/MembershipType/RetrieveMembershipTypeById?";
        if (membershipTypeId === null)
            throw new Error("The parameter 'membershipTypeId' cannot be null.");
        else if (membershipTypeId !== undefined)
            url_ += "membershipTypeId=" + encodeURIComponent("" + membershipTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveMembershipTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveMembershipTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipTypeDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipTypeDataAdministrationResult>;
        }));
    }

    protected processRetrieveMembershipTypeById(response: HttpResponseBase): Observable<MembershipTypeDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipTypeDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editMembershipType(body: MembershipTypeData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/MembershipType/EditMembershipType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditMembershipType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditMembershipType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditMembershipType(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMembershipType(body: MembershipTypeData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/MembershipType/AddMembershipType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMembershipType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMembershipType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddMembershipType(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    replaceEmployeeWithAddingPriorityWDC(body: ReplaceEmployeeData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/PriorityWorkDayConfig/ReplaceEmployeeWithAddingPriorityWDC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceEmployeeWithAddingPriorityWDC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceEmployeeWithAddingPriorityWDC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processReplaceEmployeeWithAddingPriorityWDC(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param removeExist (optional) 
     * @param body (optional) 
     * @return Success
     */
    addPriorityWorkDayConfigs(removeExist: boolean | undefined, body: AddPriorityWorkDayConfigs | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/PriorityWorkDayConfig/AddPriorityWorkDayConfigs?";
        if (removeExist === null)
            throw new Error("The parameter 'removeExist' cannot be null.");
        else if (removeExist !== undefined)
            url_ += "removeExist=" + encodeURIComponent("" + removeExist) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPriorityWorkDayConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPriorityWorkDayConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddPriorityWorkDayConfigs(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeProfileId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addPriorityWorkDayConfig(employeeProfileId: number | undefined, body: AddPriorityWorkDayConfig | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/PriorityWorkDayConfig/AddPriorityWorkDayConfig?";
        if (employeeProfileId === null)
            throw new Error("The parameter 'employeeProfileId' cannot be null.");
        else if (employeeProfileId !== undefined)
            url_ += "employeeProfileId=" + encodeURIComponent("" + employeeProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPriorityWorkDayConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPriorityWorkDayConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddPriorityWorkDayConfig(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePriorityWorkDayConfig(body: PriorityWorkDayConfigData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/PriorityWorkDayConfig/UpdatePriorityWorkDayConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePriorityWorkDayConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePriorityWorkDayConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processUpdatePriorityWorkDayConfig(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    retrieveAllPriorityWorkDayConfigs(): Observable<PriorityWorkDayConfigDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/PriorityWorkDayConfig/RetrieveAllPriorityWorkDayConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllPriorityWorkDayConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllPriorityWorkDayConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorityWorkDayConfigDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorityWorkDayConfigDataListAdministrationResult>;
        }));
    }

    protected processRetrieveAllPriorityWorkDayConfigs(response: HttpResponseBase): Observable<PriorityWorkDayConfigDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriorityWorkDayConfigDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param removeExist (optional) 
     * @param body (optional) 
     * @return Success
     */
    removeScheduleForDayByAddingPriorityWDC(removeExist: boolean | undefined, body: AddPriorityWorkDayConfigs | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/PriorityWorkDayConfig/RemoveScheduleForDayByAddingPriorityWDC?";
        if (removeExist === null)
            throw new Error("The parameter 'removeExist' cannot be null.");
        else if (removeExist !== undefined)
            url_ += "removeExist=" + encodeURIComponent("" + removeExist) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveScheduleForDayByAddingPriorityWDC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveScheduleForDayByAddingPriorityWDC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processRemoveScheduleForDayByAddingPriorityWDC(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addSchedule(body: AddScheduleData[] | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Schedule/AddSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddSchedule(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateScheduleRange(body: UpdateScheduleData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Schedule/UpdateScheduleRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduleRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduleRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processUpdateScheduleRange(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param scheduleId (optional) 
     * @return Success
     */
    deactivateSchedule(scheduleId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Schedule/DeactivateSchedule?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeactivateSchedule(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    deactivateSchedulesByEmployeeId(employeeId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Schedule/DeactivateSchedulesByEmployeeId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateSchedulesByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateSchedulesByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeactivateSchedulesByEmployeeId(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param scheduleId (optional) 
     * @return Success
     */
    retrieveScheduleById(scheduleId: number | undefined): Observable<ScheduleDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Schedule/RetrieveScheduleById?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveScheduleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveScheduleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDataAdministrationResult>;
        }));
    }

    protected processRetrieveScheduleById(response: HttpResponseBase): Observable<ScheduleDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeProfileId (optional) 
     * @return Success
     */
    retrieveAllSchedules(employeeProfileId: number | undefined): Observable<ScheduleDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Schedule/RetrieveAllSchedules?";
        if (employeeProfileId === null)
            throw new Error("The parameter 'employeeProfileId' cannot be null.");
        else if (employeeProfileId !== undefined)
            url_ += "employeeProfileId=" + encodeURIComponent("" + employeeProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDataListAdministrationResult>;
        }));
    }

    protected processRetrieveAllSchedules(response: HttpResponseBase): Observable<ScheduleDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeProfileId (optional) 
     * @return Success
     */
    retrieveAllActiveUnpassedEmployeeSchedulesBasic(employeeProfileId: number | undefined): Observable<ScheduleDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Schedule/RetrieveAllActiveUnpassedEmployeeSchedulesBasic?";
        if (employeeProfileId === null)
            throw new Error("The parameter 'employeeProfileId' cannot be null.");
        else if (employeeProfileId !== undefined)
            url_ += "employeeProfileId=" + encodeURIComponent("" + employeeProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllActiveUnpassedEmployeeSchedulesBasic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllActiveUnpassedEmployeeSchedulesBasic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDataListAdministrationResult>;
        }));
    }

    protected processRetrieveAllActiveUnpassedEmployeeSchedulesBasic(response: HttpResponseBase): Observable<ScheduleDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    retrieveSchedulesByEmployeeId(employeeId: number | undefined): Observable<ScheduleDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Schedule/RetrieveSchedulesByEmployeeId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveSchedulesByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveSchedulesByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDataListAdministrationResult>;
        }));
    }

    protected processRetrieveSchedulesByEmployeeId(response: HttpResponseBase): Observable<ScheduleDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNegatedSchedulesByWorkingHoursDailyConfigsChange(body: AddWorkingHoursDailyConfigs | undefined): Observable<ScheduleDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Schedule/UpdateNegatedSchedulesByWorkingHoursDailyConfigsChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNegatedSchedulesByWorkingHoursDailyConfigsChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNegatedSchedulesByWorkingHoursDailyConfigsChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDataListAdministrationResult>;
        }));
    }

    protected processUpdateNegatedSchedulesByWorkingHoursDailyConfigsChange(response: HttpResponseBase): Observable<ScheduleDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrievePeriodicScheduleEntries(body: PeriodicScheduleGroupsAvailabilityArgs | undefined): Observable<PeriodicScheduleEntriesResultDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Schedule/RetrievePeriodicScheduleEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePeriodicScheduleEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePeriodicScheduleEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeriodicScheduleEntriesResultDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeriodicScheduleEntriesResultDataAdministrationResult>;
        }));
    }

    protected processRetrievePeriodicScheduleEntries(response: HttpResponseBase): Observable<PeriodicScheduleEntriesResultDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodicScheduleEntriesResultDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAvailability(body: DailyAvailabilityArgs | undefined): Observable<DateTimeAvailabilityDataDictionaryAdministrationResult> {
        let url_ = this.baseUrl + "/api/Schedule/RetrieveAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTimeAvailabilityDataDictionaryAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTimeAvailabilityDataDictionaryAdministrationResult>;
        }));
    }

    protected processRetrieveAvailability(response: HttpResponseBase): Observable<DateTimeAvailabilityDataDictionaryAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateTimeAvailabilityDataDictionaryAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServices(body: PaginationArgs | undefined): Observable<ServiceDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Service/RetrieveAllServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllServices(response: HttpResponseBase): Observable<ServiceDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveServiceById(serviceId: number | undefined): Observable<ServiceDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Service/RetrieveServiceById?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveServiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveServiceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataAdministrationResult>;
        }));
    }

    protected processRetrieveServiceById(response: HttpResponseBase): Observable<ServiceDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editService(body: ServiceData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Service/EditService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditService(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addService(body: ServiceData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Service/AddService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddService(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    deactivateService(serviceId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Service/DeactivateService?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeactivateService(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    activateService(serviceId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Service/ActivateService?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processActivateService(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    removeService(serviceId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Service/RemoveService?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processRemoveService(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    retrieveAllServiceCategories(): Observable<ServiceCategoryDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ServiceCategory/RetrieveAllServiceCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllServiceCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllServiceCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCategoryDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCategoryDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllServiceCategories(response: HttpResponseBase): Observable<ServiceCategoryDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCategoryDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServiceCategoriesPaginated(body: PaginationArgs | undefined): Observable<ServiceCategoryDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ServiceCategory/RetrieveAllServiceCategoriesPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllServiceCategoriesPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllServiceCategoriesPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCategoryDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCategoryDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllServiceCategoriesPaginated(response: HttpResponseBase): Observable<ServiceCategoryDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCategoryDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceCategoryId (optional) 
     * @return Success
     */
    retrieveServiceCategoryById(serviceCategoryId: number | undefined): Observable<ServiceCategoryDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ServiceCategory/RetrieveServiceCategoryById?";
        if (serviceCategoryId === null)
            throw new Error("The parameter 'serviceCategoryId' cannot be null.");
        else if (serviceCategoryId !== undefined)
            url_ += "serviceCategoryId=" + encodeURIComponent("" + serviceCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveServiceCategoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveServiceCategoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCategoryDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCategoryDataAdministrationResult>;
        }));
    }

    protected processRetrieveServiceCategoryById(response: HttpResponseBase): Observable<ServiceCategoryDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCategoryDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editServiceCategory(body: ServiceCategoryData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceCategory/EditServiceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditServiceCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditServiceCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditServiceCategory(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceCategory(body: ServiceCategoryData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceCategory/AddServiceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddServiceCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddServiceCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddServiceCategory(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceCategoryId (optional) 
     * @return Success
     */
    deactivateServiceCategory(serviceCategoryId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceCategory/DeactivateServiceCategory?";
        if (serviceCategoryId === null)
            throw new Error("The parameter 'serviceCategoryId' cannot be null.");
        else if (serviceCategoryId !== undefined)
            url_ += "serviceCategoryId=" + encodeURIComponent("" + serviceCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateServiceCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateServiceCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeactivateServiceCategory(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServiceDiscounts(body: PaginationArgs | undefined): Observable<ServiceDiscountDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ServiceDiscount/RetrieveAllServiceDiscounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllServiceDiscounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllServiceDiscounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDiscountDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDiscountDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllServiceDiscounts(response: HttpResponseBase): Observable<ServiceDiscountDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDiscountDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceDiscountId (optional) 
     * @return Success
     */
    retrieveServiceDiscountById(serviceDiscountId: number | undefined): Observable<ServiceDiscountDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ServiceDiscount/RetrieveServiceDiscountById?";
        if (serviceDiscountId === null)
            throw new Error("The parameter 'serviceDiscountId' cannot be null.");
        else if (serviceDiscountId !== undefined)
            url_ += "serviceDiscountId=" + encodeURIComponent("" + serviceDiscountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveServiceDiscountById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveServiceDiscountById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDiscountDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDiscountDataAdministrationResult>;
        }));
    }

    protected processRetrieveServiceDiscountById(response: HttpResponseBase): Observable<ServiceDiscountDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDiscountDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editServiceDiscount(body: ServiceDiscountData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceDiscount/EditServiceDiscount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditServiceDiscount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditServiceDiscount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditServiceDiscount(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceDiscount(body: ServiceDiscountData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceDiscount/AddServiceDiscount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddServiceDiscount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddServiceDiscount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddServiceDiscount(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceDiscountId (optional) 
     * @return Success
     */
    deleteServiceDiscount(serviceDiscountId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceDiscount/DeleteServiceDiscount?";
        if (serviceDiscountId === null)
            throw new Error("The parameter 'serviceDiscountId' cannot be null.");
        else if (serviceDiscountId !== undefined)
            url_ += "serviceDiscountId=" + encodeURIComponent("" + serviceDiscountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceDiscount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceDiscount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeleteServiceDiscount(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllServiceTypes(body: PaginationArgs | undefined): Observable<ServiceTypeDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ServiceType/RetrieveAllServiceTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllServiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTypeDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTypeDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllServiceTypes(response: HttpResponseBase): Observable<ServiceTypeDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTypeDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceTypeId (optional) 
     * @return Success
     */
    retrieveServiceTypeById(serviceTypeId: number | undefined): Observable<ServiceTypeDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ServiceType/RetrieveServiceTypeById?";
        if (serviceTypeId === null)
            throw new Error("The parameter 'serviceTypeId' cannot be null.");
        else if (serviceTypeId !== undefined)
            url_ += "serviceTypeId=" + encodeURIComponent("" + serviceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveServiceTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveServiceTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTypeDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTypeDataAdministrationResult>;
        }));
    }

    protected processRetrieveServiceTypeById(response: HttpResponseBase): Observable<ServiceTypeDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTypeDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editServiceType(body: ServiceTypeData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceType/EditServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditServiceType(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceType(body: ServiceTypeData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceType/AddServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddServiceType(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceTypeId (optional) 
     * @return Success
     */
    deleteServiceType(serviceTypeId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ServiceType/DeleteServiceType?";
        if (serviceTypeId === null)
            throw new Error("The parameter 'serviceTypeId' cannot be null.");
        else if (serviceTypeId !== undefined)
            url_ += "serviceTypeId=" + encodeURIComponent("" + serviceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeleteServiceType(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    retrieveAllShiftTemplates(): Observable<ShiftTemplateDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/ShiftTemplate/RetrieveAllShiftTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllShiftTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllShiftTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftTemplateDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftTemplateDataListAdministrationResult>;
        }));
    }

    protected processRetrieveAllShiftTemplates(response: HttpResponseBase): Observable<ShiftTemplateDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftTemplateDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addShiftTemplate(body: AddShiftTemplateData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ShiftTemplate/AddShiftTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddShiftTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddShiftTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddShiftTemplate(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShiftTemplate(body: UpdateShiftTemplateData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ShiftTemplate/UpdateShiftTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShiftTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processUpdateShiftTemplate(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftTemplateId (optional) 
     * @return Success
     */
    retrieveShiftTemplateById(shiftTemplateId: number | undefined): Observable<ShiftTemplateDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/ShiftTemplate/RetrieveShiftTemplateById?";
        if (shiftTemplateId === null)
            throw new Error("The parameter 'shiftTemplateId' cannot be null.");
        else if (shiftTemplateId !== undefined)
            url_ += "shiftTemplateId=" + encodeURIComponent("" + shiftTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveShiftTemplateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveShiftTemplateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftTemplateDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftTemplateDataAdministrationResult>;
        }));
    }

    protected processRetrieveShiftTemplateById(response: HttpResponseBase): Observable<ShiftTemplateDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftTemplateDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftTemplateId (optional) 
     * @return Success
     */
    deleteShiftTemplate(shiftTemplateId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/ShiftTemplate/DeleteShiftTemplate?";
        if (shiftTemplateId === null)
            throw new Error("The parameter 'shiftTemplateId' cannot be null.");
        else if (shiftTemplateId !== undefined)
            url_ += "shiftTemplateId=" + encodeURIComponent("" + shiftTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShiftTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShiftTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processDeleteShiftTemplate(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllTerms(body: PaginationArgs | undefined): Observable<TermDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Term/RetrieveAllTerms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllTerms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllTerms(response: HttpResponseBase): Observable<TermDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param termId (optional) 
     * @return Success
     */
    retrieveTermById(termId: number | undefined): Observable<TermDataAdministrationResult> {
        let url_ = this.baseUrl + "/api/Term/RetrieveTermById?";
        if (termId === null)
            throw new Error("The parameter 'termId' cannot be null.");
        else if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveTermById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveTermById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermDataAdministrationResult>;
        }));
    }

    protected processRetrieveTermById(response: HttpResponseBase): Observable<TermDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveTermsByTermSearchArgs(body: TermSearchArgs | undefined): Observable<TermDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Term/RetrieveTermsByTermSearchArgs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveTermsByTermSearchArgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveTermsByTermSearchArgs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermDataListAdministrationResult>;
        }));
    }

    protected processRetrieveTermsByTermSearchArgs(response: HttpResponseBase): Observable<TermDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editTerm(body: TermData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Term/EditTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditTerm(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param termId (optional) 
     * @return Success
     */
    cancelTerm(termId: number | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/api/Term/CancelTerm?";
        if (termId === null)
            throw new Error("The parameter 'termId' cannot be null.");
        else if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processCancelTerm(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveGeneratedTimeSlots(body: RetrieveGeneratedTimeSlotsData | undefined): Observable<TermDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Term/RetrieveGeneratedTimeSlots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveGeneratedTimeSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveGeneratedTimeSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermDataListAdministrationResult>;
        }));
    }

    protected processRetrieveGeneratedTimeSlots(response: HttpResponseBase): Observable<TermDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateAlternativeTimeSlots(body: TermData | undefined): Observable<TermDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Term/GenerateAlternativeTimeSlots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAlternativeTimeSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAlternativeTimeSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermDataListAdministrationResult>;
        }));
    }

    protected processGenerateAlternativeTimeSlots(response: HttpResponseBase): Observable<TermDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveNegatedTermsByWorkingHoursDailyConfigs(body: AddWorkingHoursDailyConfigs | undefined): Observable<TermDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Term/RetrieveNegatedTermsByWorkingHoursDailyConfigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveNegatedTermsByWorkingHoursDailyConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveNegatedTermsByWorkingHoursDailyConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermDataListAdministrationResult>;
        }));
    }

    protected processRetrieveNegatedTermsByWorkingHoursDailyConfigs(response: HttpResponseBase): Observable<TermDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveNegatedTermsByServiceRemoval(body: ServiceData[] | undefined): Observable<TermDataListAdministrationResult> {
        let url_ = this.baseUrl + "/api/Term/RetrieveNegatedTermsByServiceRemoval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveNegatedTermsByServiceRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveNegatedTermsByServiceRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermDataListAdministrationResult>;
        }));
    }

    protected processRetrieveNegatedTermsByServiceRemoval(response: HttpResponseBase): Observable<TermDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @param code (optional) 
     * @return Success
     */
    verifyEmail(key: number | undefined, code: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/User/VerifyEmail?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginRequestData | undefined): Observable<LoginUserDataSecurityResult> {
        let url_ = this.baseUrl + "/User/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginUserDataSecurityResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginUserDataSecurityResult>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginUserDataSecurityResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginUserDataSecurityResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    signout(): Observable<SecurityResultStatus> {
        let url_ = this.baseUrl + "/User/Signout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResultStatus>;
        }));
    }

    protected processSignout(response: HttpResponseBase): Observable<SecurityResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordRequestData | undefined): Observable<SecurityResultStatus> {
        let url_ = this.baseUrl + "/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResultStatus>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<SecurityResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    changePasswordForUser(userId: number | undefined, body: ChangePasswordForUserRequestData | undefined): Observable<SecurityResultStatus> {
        let url_ = this.baseUrl + "/User/ChangePasswordForUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePasswordForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResultStatus>;
        }));
    }

    protected processChangePasswordForUser(response: HttpResponseBase): Observable<SecurityResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    retrieveUserDetail(userId: number | undefined): Observable<UserRoleDataAdministrationResult> {
        let url_ = this.baseUrl + "/User/RetrieveUserDetail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDataAdministrationResult>;
        }));
    }

    protected processRetrieveUserDetail(response: HttpResponseBase): Observable<UserRoleDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailOrPhoneNumber (optional) 
     * @return Success
     */
    generateResetPasswordCode(emailOrPhoneNumber: string | undefined): Observable<Int32SecurityResult> {
        let url_ = this.baseUrl + "/User/GenerateResetPasswordCode?";
        if (emailOrPhoneNumber === null)
            throw new Error("The parameter 'emailOrPhoneNumber' cannot be null.");
        else if (emailOrPhoneNumber !== undefined)
            url_ += "emailOrPhoneNumber=" + encodeURIComponent("" + emailOrPhoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateResetPasswordCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateResetPasswordCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32SecurityResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32SecurityResult>;
        }));
    }

    protected processGenerateResetPasswordCode(response: HttpResponseBase): Observable<Int32SecurityResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32SecurityResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @param resertPasswordCode (optional) 
     * @param newPassword (optional) 
     * @return Success
     */
    resetPasswordWithCode(key: number | undefined, resertPasswordCode: string | undefined, newPassword: string | undefined): Observable<SecurityResultStatus> {
        let url_ = this.baseUrl + "/User/ResetPasswordWithCode?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (resertPasswordCode === null)
            throw new Error("The parameter 'resertPasswordCode' cannot be null.");
        else if (resertPasswordCode !== undefined)
            url_ += "resertPasswordCode=" + encodeURIComponent("" + resertPasswordCode) + "&";
        if (newPassword === null)
            throw new Error("The parameter 'newPassword' cannot be null.");
        else if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordWithCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordWithCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResultStatus>;
        }));
    }

    protected processResetPasswordWithCode(response: HttpResponseBase): Observable<SecurityResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUser(body: UserProfileData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/User/EditUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processEditUser(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUser(body: UserProfileData | undefined): Observable<AdministrationResultStatus> {
        let url_ = this.baseUrl + "/User/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationResultStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationResultStatus>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<AdministrationResultStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isEmployee (optional) 
     * @param body (optional) 
     * @return Success
     */
    retrieveAllUsersPaginated(isEmployee: boolean | undefined, body: PaginationArgs | undefined): Observable<UserProfileDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/User/RetrieveAllUsersPaginated?";
        if (isEmployee === null)
            throw new Error("The parameter 'isEmployee' cannot be null.");
        else if (isEmployee !== undefined)
            url_ += "isEmployee=" + encodeURIComponent("" + isEmployee) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllUsersPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllUsersPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllUsersPaginated(response: HttpResponseBase): Observable<UserProfileDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param date (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    retrieveAllUsers(roleId: number | undefined, date: Date | undefined, serviceId: number | undefined): Observable<UserProfileDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/User/RetrieveAllUsers?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllUsers(response: HttpResponseBase): Observable<UserProfileDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    retrieveUserById(userId: number | undefined): Observable<UserProfileDataAdministrationResult> {
        let url_ = this.baseUrl + "/User/RetrieveUserById?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDataAdministrationResult>;
        }));
    }

    protected processRetrieveUserById(response: HttpResponseBase): Observable<UserProfileDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllEmployeesWithServices(body: PaginationArgs | undefined): Observable<UserProfileDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/User/RetrieveAllEmployeesWithServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllEmployeesWithServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllEmployeesWithServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllEmployeesWithServices(response: HttpResponseBase): Observable<UserProfileDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retrieveAllProfilesFromClients(body: PaginationArgs | undefined): Observable<UserProfileDataPaginationDataAdministrationResult> {
        let url_ = this.baseUrl + "/User/RetrieveAllProfilesFromClients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllProfilesFromClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllProfilesFromClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDataPaginationDataAdministrationResult>;
        }));
    }

    protected processRetrieveAllProfilesFromClients(response: HttpResponseBase): Observable<UserProfileDataPaginationDataAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDataPaginationDataAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    retrieveAllUserRoles(): Observable<UserRoleDataListAdministrationResult> {
        let url_ = this.baseUrl + "/User/RetrieveAllUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDataListAdministrationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDataListAdministrationResult>;
        }));
    }

    protected processRetrieveAllUserRoles(response: HttpResponseBase): Observable<UserRoleDataListAdministrationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDataListAdministrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddBookingData implements IAddBookingData {
    profileId?: number | undefined;
    serviceId?: number;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    termsList?: BookedTermData[] | undefined;

    constructor(data?: IAddBookingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.email = _data["email"];
            if (Array.isArray(_data["termsList"])) {
                this.termsList = [] as any;
                for (let item of _data["termsList"])
                    this.termsList!.push(BookedTermData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddBookingData {
        data = typeof data === 'object' ? data : {};
        let result = new AddBookingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["email"] = this.email;
        if (Array.isArray(this.termsList)) {
            data["termsList"] = [];
            for (let item of this.termsList)
                data["termsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddBookingData {
    profileId?: number | undefined;
    serviceId?: number;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    termsList?: BookedTermData[] | undefined;
}

export class AddConfigurationData implements IAddConfigurationData {
    possibleNegativeCredits?: number;
    timeBetweenGeneratedTermsInMinutes?: number;
    pauseTimeAfterTermsInMinutes?: number | undefined;
    workingHours?: AddWorkingHoursDailyConfigs;

    constructor(data?: IAddConfigurationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.possibleNegativeCredits = _data["possibleNegativeCredits"];
            this.timeBetweenGeneratedTermsInMinutes = _data["timeBetweenGeneratedTermsInMinutes"];
            this.pauseTimeAfterTermsInMinutes = _data["pauseTimeAfterTermsInMinutes"];
            this.workingHours = _data["workingHours"] ? AddWorkingHoursDailyConfigs.fromJS(_data["workingHours"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddConfigurationData {
        data = typeof data === 'object' ? data : {};
        let result = new AddConfigurationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["possibleNegativeCredits"] = this.possibleNegativeCredits;
        data["timeBetweenGeneratedTermsInMinutes"] = this.timeBetweenGeneratedTermsInMinutes;
        data["pauseTimeAfterTermsInMinutes"] = this.pauseTimeAfterTermsInMinutes;
        data["workingHours"] = this.workingHours ? this.workingHours.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddConfigurationData {
    possibleNegativeCredits?: number;
    timeBetweenGeneratedTermsInMinutes?: number;
    pauseTimeAfterTermsInMinutes?: number | undefined;
    workingHours?: AddWorkingHoursDailyConfigs;
}

export class AddPriorityWorkDayConfig implements IAddPriorityWorkDayConfig {
    forDate?: Date;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;

    constructor(data?: IAddPriorityWorkDayConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forDate = _data["forDate"] ? new Date(_data["forDate"].toString()) : <any>undefined;
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.working = _data["working"];
        }
    }

    static fromJS(data: any): AddPriorityWorkDayConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AddPriorityWorkDayConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forDate"] = this.forDate ? this.forDate.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["working"] = this.working;
        return data;
    }
}

export interface IAddPriorityWorkDayConfig {
    forDate?: Date;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;
}

export class AddPriorityWorkDayConfigs implements IAddPriorityWorkDayConfigs {
    employeeProfileId?: number;
    priorityWorkDayConfigList?: AddPriorityWorkDayConfig[] | undefined;

    constructor(data?: IAddPriorityWorkDayConfigs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeProfileId = _data["employeeProfileId"];
            if (Array.isArray(_data["priorityWorkDayConfigList"])) {
                this.priorityWorkDayConfigList = [] as any;
                for (let item of _data["priorityWorkDayConfigList"])
                    this.priorityWorkDayConfigList!.push(AddPriorityWorkDayConfig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddPriorityWorkDayConfigs {
        data = typeof data === 'object' ? data : {};
        let result = new AddPriorityWorkDayConfigs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeProfileId"] = this.employeeProfileId;
        if (Array.isArray(this.priorityWorkDayConfigList)) {
            data["priorityWorkDayConfigList"] = [];
            for (let item of this.priorityWorkDayConfigList)
                data["priorityWorkDayConfigList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddPriorityWorkDayConfigs {
    employeeProfileId?: number;
    priorityWorkDayConfigList?: AddPriorityWorkDayConfig[] | undefined;
}

export class AddScheduleData implements IAddScheduleData {
    employeeProfileId?: number;
    startingFrom?: Date;
    endOn?: Date;
    workWeekList?: AddWorkWeekConfigData[] | undefined;

    constructor(data?: IAddScheduleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeProfileId = _data["employeeProfileId"];
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["workWeekList"])) {
                this.workWeekList = [] as any;
                for (let item of _data["workWeekList"])
                    this.workWeekList!.push(AddWorkWeekConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddScheduleData {
        data = typeof data === 'object' ? data : {};
        let result = new AddScheduleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeProfileId"] = this.employeeProfileId;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        if (Array.isArray(this.workWeekList)) {
            data["workWeekList"] = [];
            for (let item of this.workWeekList)
                data["workWeekList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddScheduleData {
    employeeProfileId?: number;
    startingFrom?: Date;
    endOn?: Date;
    workWeekList?: AddWorkWeekConfigData[] | undefined;
}

export class AddShiftTemplateData implements IAddShiftTemplateData {
    name?: string | undefined;
    description?: string | undefined;
    startingFrom?: Date;
    endOn?: Date;
    repeating?: boolean;
    workWeekList?: AddWorkWeekConfigData[] | undefined;

    constructor(data?: IAddShiftTemplateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.repeating = _data["repeating"];
            if (Array.isArray(_data["workWeekList"])) {
                this.workWeekList = [] as any;
                for (let item of _data["workWeekList"])
                    this.workWeekList!.push(AddWorkWeekConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddShiftTemplateData {
        data = typeof data === 'object' ? data : {};
        let result = new AddShiftTemplateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["repeating"] = this.repeating;
        if (Array.isArray(this.workWeekList)) {
            data["workWeekList"] = [];
            for (let item of this.workWeekList)
                data["workWeekList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddShiftTemplateData {
    name?: string | undefined;
    description?: string | undefined;
    startingFrom?: Date;
    endOn?: Date;
    repeating?: boolean;
    workWeekList?: AddWorkWeekConfigData[] | undefined;
}

export class AddWorkDayConfigData implements IAddWorkDayConfigData {
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;
    enabled?: boolean;

    constructor(data?: IAddWorkDayConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.working = _data["working"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): AddWorkDayConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkDayConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["working"] = this.working;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IAddWorkDayConfigData {
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;
    enabled?: boolean;
}

export class AddWorkWeekConfigData implements IAddWorkWeekConfigData {
    workDaysConfig?: AddWorkDayConfigData[] | undefined;

    constructor(data?: IAddWorkWeekConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workDaysConfig"])) {
                this.workDaysConfig = [] as any;
                for (let item of _data["workDaysConfig"])
                    this.workDaysConfig!.push(AddWorkDayConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddWorkWeekConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkWeekConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workDaysConfig)) {
            data["workDaysConfig"] = [];
            for (let item of this.workDaysConfig)
                data["workDaysConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddWorkWeekConfigData {
    workDaysConfig?: AddWorkDayConfigData[] | undefined;
}

export class AddWorkingHoursDailyConfig implements IAddWorkingHoursDailyConfig {
    fromTime?: Date;
    toTime?: Date;
    working?: boolean | undefined;

    constructor(data?: IAddWorkingHoursDailyConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.working = _data["working"];
        }
    }

    static fromJS(data: any): AddWorkingHoursDailyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkingHoursDailyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["working"] = this.working;
        return data;
    }
}

export interface IAddWorkingHoursDailyConfig {
    fromTime?: Date;
    toTime?: Date;
    working?: boolean | undefined;
}

export class AddWorkingHoursDailyConfigs implements IAddWorkingHoursDailyConfigs {
    mondayWorkingHours?: AddWorkingHoursDailyConfig;
    tuesdayWorkingHours?: AddWorkingHoursDailyConfig;
    wednesdayWorkingHours?: AddWorkingHoursDailyConfig;
    thursdayWorkingHours?: AddWorkingHoursDailyConfig;
    fridayWorkingHours?: AddWorkingHoursDailyConfig;
    saturdayWorkingHours?: AddWorkingHoursDailyConfig;
    sundayWorkingHours?: AddWorkingHoursDailyConfig;

    constructor(data?: IAddWorkingHoursDailyConfigs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mondayWorkingHours = _data["mondayWorkingHours"] ? AddWorkingHoursDailyConfig.fromJS(_data["mondayWorkingHours"]) : <any>undefined;
            this.tuesdayWorkingHours = _data["tuesdayWorkingHours"] ? AddWorkingHoursDailyConfig.fromJS(_data["tuesdayWorkingHours"]) : <any>undefined;
            this.wednesdayWorkingHours = _data["wednesdayWorkingHours"] ? AddWorkingHoursDailyConfig.fromJS(_data["wednesdayWorkingHours"]) : <any>undefined;
            this.thursdayWorkingHours = _data["thursdayWorkingHours"] ? AddWorkingHoursDailyConfig.fromJS(_data["thursdayWorkingHours"]) : <any>undefined;
            this.fridayWorkingHours = _data["fridayWorkingHours"] ? AddWorkingHoursDailyConfig.fromJS(_data["fridayWorkingHours"]) : <any>undefined;
            this.saturdayWorkingHours = _data["saturdayWorkingHours"] ? AddWorkingHoursDailyConfig.fromJS(_data["saturdayWorkingHours"]) : <any>undefined;
            this.sundayWorkingHours = _data["sundayWorkingHours"] ? AddWorkingHoursDailyConfig.fromJS(_data["sundayWorkingHours"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddWorkingHoursDailyConfigs {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkingHoursDailyConfigs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mondayWorkingHours"] = this.mondayWorkingHours ? this.mondayWorkingHours.toJSON() : <any>undefined;
        data["tuesdayWorkingHours"] = this.tuesdayWorkingHours ? this.tuesdayWorkingHours.toJSON() : <any>undefined;
        data["wednesdayWorkingHours"] = this.wednesdayWorkingHours ? this.wednesdayWorkingHours.toJSON() : <any>undefined;
        data["thursdayWorkingHours"] = this.thursdayWorkingHours ? this.thursdayWorkingHours.toJSON() : <any>undefined;
        data["fridayWorkingHours"] = this.fridayWorkingHours ? this.fridayWorkingHours.toJSON() : <any>undefined;
        data["saturdayWorkingHours"] = this.saturdayWorkingHours ? this.saturdayWorkingHours.toJSON() : <any>undefined;
        data["sundayWorkingHours"] = this.sundayWorkingHours ? this.sundayWorkingHours.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddWorkingHoursDailyConfigs {
    mondayWorkingHours?: AddWorkingHoursDailyConfig;
    tuesdayWorkingHours?: AddWorkingHoursDailyConfig;
    wednesdayWorkingHours?: AddWorkingHoursDailyConfig;
    thursdayWorkingHours?: AddWorkingHoursDailyConfig;
    fridayWorkingHours?: AddWorkingHoursDailyConfig;
    saturdayWorkingHours?: AddWorkingHoursDailyConfig;
    sundayWorkingHours?: AddWorkingHoursDailyConfig;
}

export enum AdministrationResultStatus {
    Success = "Success",
    Updated = "Updated",
    ServerError = "ServerError",
    ArgumentsException = "ArgumentsException",
    NotFound = "NotFound",
    WrongCreditials = "WrongCreditials",
    UserNotValidated = "UserNotValidated",
    Error = "Error",
    NotAuthenticated = "NotAuthenticated",
    AlreadyViewed = "AlreadyViewed",
    AlreadyBooked = "AlreadyBooked",
    AlreadyCancelled = "AlreadyCancelled",
    FailedToAddTerm = "FailedToAddTerm",
    EmployeeNotAvailable = "EmployeeNotAvailable",
    Holiday = "Holiday",
    UserAlreadyExists = "UserAlreadyExists",
    RecordAlreadyExists = "RecordAlreadyExists",
    UsernameAlreadyTaken = "UsernameAlreadyTaken",
    EmailAlreadyTaken = "EmailAlreadyTaken",
    PhoneAlreadyExists = "PhoneAlreadyExists",
    PriorityDayAlreadyExists = "PriorityDayAlreadyExists",
    OverlapingTerms = "OverlapingTerms",
    OverlapingServiceDays = "OverlapingServiceDays",
    ServiceUnavailableAtSpecifiedTime = "ServiceUnavailableAtSpecifiedTime",
    NegativeCreditsLimitPassed = "NegativeCreditsLimitPassed",
    NotEnoughCredits = "NotEnoughCredits",
    NoTerms = "NoTerms",
    OverlappingTimeSlots = "OverlappingTimeSlots",
    OverlappingDates = "OverlappingDates",
    InvalidDate = "InvalidDate",
    InvalidTimeSlot = "InvalidTimeSlot",
    InvalidConfiguration = "InvalidConfiguration",
    InvalidArguments = "InvalidArguments",
    TrialSessionAlreadyUsed = "TrialSessionAlreadyUsed",
    ActiveMembership = "ActiveMembership",
}

export class AvailabilityData implements IAvailabilityData {
    status?: AvailabilityStatusEnum;
    hourlyAvailability?: Date[] | undefined;
    dayConfigs?: WorkDayConfigAvailabilityData[] | undefined;

    constructor(data?: IAvailabilityData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["hourlyAvailability"])) {
                this.hourlyAvailability = [] as any;
                for (let item of _data["hourlyAvailability"])
                    this.hourlyAvailability!.push(new Date(item));
            }
            if (Array.isArray(_data["dayConfigs"])) {
                this.dayConfigs = [] as any;
                for (let item of _data["dayConfigs"])
                    this.dayConfigs!.push(WorkDayConfigAvailabilityData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailabilityData {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.hourlyAvailability)) {
            data["hourlyAvailability"] = [];
            for (let item of this.hourlyAvailability)
                data["hourlyAvailability"].push(item.toISOString());
        }
        if (Array.isArray(this.dayConfigs)) {
            data["dayConfigs"] = [];
            for (let item of this.dayConfigs)
                data["dayConfigs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailabilityData {
    status?: AvailabilityStatusEnum;
    hourlyAvailability?: Date[] | undefined;
    dayConfigs?: WorkDayConfigAvailabilityData[] | undefined;
}

export enum AvailabilityStatusEnum {
    Available = "Available",
    InSchedule = "InSchedule",
    Unavailable = "Unavailable",
    Holiday = "Holiday",
    Unknown = "Unknown",
}

export class BookedTermData implements IBookedTermData {
    employeeProfileId?: number;
    fromDate?: Date;
    rescheduledTermId?: number | undefined;
    recurringTermGroupId?: number | undefined;

    constructor(data?: IBookedTermData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeProfileId = _data["employeeProfileId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.rescheduledTermId = _data["rescheduledTermId"];
            this.recurringTermGroupId = _data["recurringTermGroupId"];
        }
    }

    static fromJS(data: any): BookedTermData {
        data = typeof data === 'object' ? data : {};
        let result = new BookedTermData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeProfileId"] = this.employeeProfileId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["rescheduledTermId"] = this.rescheduledTermId;
        data["recurringTermGroupId"] = this.recurringTermGroupId;
        return data;
    }
}

export interface IBookedTermData {
    employeeProfileId?: number;
    fromDate?: Date;
    rescheduledTermId?: number | undefined;
    recurringTermGroupId?: number | undefined;
}

export class BookingData implements IBookingData {
    id?: number;
    profileId?: number | undefined;
    serviceId?: number;
    cancelled?: boolean;
    bookedOn?: Date | undefined;
    bookingToken?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    anonymousEmail?: string | undefined;
    email?: string | undefined;
    serviceName?: string | undefined;
    serviceDuration?: number;
    servicePrice?: number;
    employeeName?: string | undefined;
    terms?: TermData[] | undefined;

    constructor(data?: IBookingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileId = _data["profileId"];
            this.serviceId = _data["serviceId"];
            this.cancelled = _data["cancelled"];
            this.bookedOn = _data["bookedOn"] ? new Date(_data["bookedOn"].toString()) : <any>undefined;
            this.bookingToken = _data["bookingToken"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.anonymousEmail = _data["anonymousEmail"];
            this.email = _data["email"];
            this.serviceName = _data["serviceName"];
            this.serviceDuration = _data["serviceDuration"];
            this.servicePrice = _data["servicePrice"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["terms"])) {
                this.terms = [] as any;
                for (let item of _data["terms"])
                    this.terms!.push(TermData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingData {
        data = typeof data === 'object' ? data : {};
        let result = new BookingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileId"] = this.profileId;
        data["serviceId"] = this.serviceId;
        data["cancelled"] = this.cancelled;
        data["bookedOn"] = this.bookedOn ? this.bookedOn.toISOString() : <any>undefined;
        data["bookingToken"] = this.bookingToken;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["anonymousEmail"] = this.anonymousEmail;
        data["email"] = this.email;
        data["serviceName"] = this.serviceName;
        data["serviceDuration"] = this.serviceDuration;
        data["servicePrice"] = this.servicePrice;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.terms)) {
            data["terms"] = [];
            for (let item of this.terms)
                data["terms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookingData {
    id?: number;
    profileId?: number | undefined;
    serviceId?: number;
    cancelled?: boolean;
    bookedOn?: Date | undefined;
    bookingToken?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    anonymousEmail?: string | undefined;
    email?: string | undefined;
    serviceName?: string | undefined;
    serviceDuration?: number;
    servicePrice?: number;
    employeeName?: string | undefined;
    terms?: TermData[] | undefined;
}

export class BookingDataAdministrationResult implements IBookingDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: BookingData;

    constructor(data?: IBookingDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? BookingData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BookingDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBookingDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: BookingData;
}

export class ChangePasswordForUserRequestData implements IChangePasswordForUserRequestData {
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordForUserRequestData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordForUserRequestData {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordForUserRequestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordForUserRequestData {
    newPassword?: string | undefined;
}

export class ChangePasswordRequestData implements IChangePasswordRequestData {
    newPassword?: string | undefined;
    oldPassword?: string | undefined;

    constructor(data?: IChangePasswordRequestData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.oldPassword = _data["oldPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequestData {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["oldPassword"] = this.oldPassword;
        return data;
    }
}

export interface IChangePasswordRequestData {
    newPassword?: string | undefined;
    oldPassword?: string | undefined;
}

export class ConfigurationParameterData implements IConfigurationParameterData {
    id?: number;
    possibleNegativeCredits?: number;
    timeBetweenGeneratedTermsInMinutes?: number;
    pauseTimeAfterTermsInMinutes?: number | undefined;
    workingHours?: WorkingHoursDailyConfigData[] | undefined;
    active?: boolean;

    constructor(data?: IConfigurationParameterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.possibleNegativeCredits = _data["possibleNegativeCredits"];
            this.timeBetweenGeneratedTermsInMinutes = _data["timeBetweenGeneratedTermsInMinutes"];
            this.pauseTimeAfterTermsInMinutes = _data["pauseTimeAfterTermsInMinutes"];
            if (Array.isArray(_data["workingHours"])) {
                this.workingHours = [] as any;
                for (let item of _data["workingHours"])
                    this.workingHours!.push(WorkingHoursDailyConfigData.fromJS(item));
            }
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ConfigurationParameterData {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationParameterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["possibleNegativeCredits"] = this.possibleNegativeCredits;
        data["timeBetweenGeneratedTermsInMinutes"] = this.timeBetweenGeneratedTermsInMinutes;
        data["pauseTimeAfterTermsInMinutes"] = this.pauseTimeAfterTermsInMinutes;
        if (Array.isArray(this.workingHours)) {
            data["workingHours"] = [];
            for (let item of this.workingHours)
                data["workingHours"].push(item.toJSON());
        }
        data["active"] = this.active;
        return data;
    }
}

export interface IConfigurationParameterData {
    id?: number;
    possibleNegativeCredits?: number;
    timeBetweenGeneratedTermsInMinutes?: number;
    pauseTimeAfterTermsInMinutes?: number | undefined;
    workingHours?: WorkingHoursDailyConfigData[] | undefined;
    active?: boolean;
}

export class ConfigurationParameterDataAdministrationResult implements IConfigurationParameterDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ConfigurationParameterData;

    constructor(data?: IConfigurationParameterDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ConfigurationParameterData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigurationParameterDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationParameterDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfigurationParameterDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ConfigurationParameterData;
}

export class DailyAvailabilityArgs implements IDailyAvailabilityArgs {
    employeeProfileId?: number | undefined;
    serviceId?: number | undefined;
    startDate?: Date;
    endDate?: Date;
    hourlyAvailabilityCheck?: boolean;
    hourlyAvailabilityCheckLimit?: number | undefined;
    editingTermId?: number | undefined;
    preBookedTermsList?: PreBookedTermData[] | undefined;

    constructor(data?: IDailyAvailabilityArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeProfileId = _data["employeeProfileId"];
            this.serviceId = _data["serviceId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hourlyAvailabilityCheck = _data["hourlyAvailabilityCheck"];
            this.hourlyAvailabilityCheckLimit = _data["hourlyAvailabilityCheckLimit"];
            this.editingTermId = _data["editingTermId"];
            if (Array.isArray(_data["preBookedTermsList"])) {
                this.preBookedTermsList = [] as any;
                for (let item of _data["preBookedTermsList"])
                    this.preBookedTermsList!.push(PreBookedTermData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyAvailabilityArgs {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAvailabilityArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeProfileId"] = this.employeeProfileId;
        data["serviceId"] = this.serviceId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hourlyAvailabilityCheck"] = this.hourlyAvailabilityCheck;
        data["hourlyAvailabilityCheckLimit"] = this.hourlyAvailabilityCheckLimit;
        data["editingTermId"] = this.editingTermId;
        if (Array.isArray(this.preBookedTermsList)) {
            data["preBookedTermsList"] = [];
            for (let item of this.preBookedTermsList)
                data["preBookedTermsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailyAvailabilityArgs {
    employeeProfileId?: number | undefined;
    serviceId?: number | undefined;
    startDate?: Date;
    endDate?: Date;
    hourlyAvailabilityCheck?: boolean;
    hourlyAvailabilityCheckLimit?: number | undefined;
    editingTermId?: number | undefined;
    preBookedTermsList?: PreBookedTermData[] | undefined;
}

export class DateTimeAvailabilityDataDictionaryAdministrationResult implements IDateTimeAvailabilityDataDictionaryAdministrationResult {
    status?: AdministrationResultStatus;
    content?: { [key: string]: AvailabilityData; } | undefined;

    constructor(data?: IDateTimeAvailabilityDataDictionaryAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? AvailabilityData.fromJS(_data["content"][key]) : new AvailabilityData();
                }
            }
        }
    }

    static fromJS(data: any): DateTimeAvailabilityDataDictionaryAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeAvailabilityDataDictionaryAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IDateTimeAvailabilityDataDictionaryAdministrationResult {
    status?: AdministrationResultStatus;
    content?: { [key: string]: AvailabilityData; } | undefined;
}

export class DayData implements IDayData {
    id?: number;
    name?: string | undefined;
    checked?: boolean;

    constructor(data?: IDayData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): DayData {
        data = typeof data === 'object' ? data : {};
        let result = new DayData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["checked"] = this.checked;
        return data;
    }
}

export interface IDayData {
    id?: number;
    name?: string | undefined;
    checked?: boolean;
}

export class DayDataListAdministrationResult implements IDayDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: DayData[] | undefined;

    constructor(data?: IDayDataListAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(DayData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DayDataListAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DayDataListAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDayDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: DayData[] | undefined;
}

export class EmployeeData implements IEmployeeData {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    active?: boolean;

    constructor(data?: IEmployeeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): EmployeeData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["active"] = this.active;
        return data;
    }
}

export interface IEmployeeData {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    active?: boolean;
}

export class EmployeeDataAdministrationResult implements IEmployeeDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: EmployeeData;

    constructor(data?: IEmployeeDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? EmployeeData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: EmployeeData;
}

export class EmployeeDataPaginationData implements IEmployeeDataPaginationData {
    items?: EmployeeData[] | undefined;
    totalCount?: number;

    constructor(data?: IEmployeeDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmployeeData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IEmployeeDataPaginationData {
    items?: EmployeeData[] | undefined;
    totalCount?: number;
}

export class EmployeeDataPaginationDataAdministrationResult implements IEmployeeDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: EmployeeDataPaginationData;

    constructor(data?: IEmployeeDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? EmployeeDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: EmployeeDataPaginationData;
}

export class EmployeeMinifiedData implements IEmployeeMinifiedData {
    employeeProfileId?: number;
    name?: string | undefined;
    surname?: string | undefined;

    constructor(data?: IEmployeeMinifiedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeProfileId = _data["employeeProfileId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): EmployeeMinifiedData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMinifiedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeProfileId"] = this.employeeProfileId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IEmployeeMinifiedData {
    employeeProfileId?: number;
    name?: string | undefined;
    surname?: string | undefined;
}

export class EmployeeServiceData implements IEmployeeServiceData {
    id?: number;
    profileId?: number;
    serviceId?: number;
    serviceName?: string | undefined;
    serviceCategoryId?: number;

    constructor(data?: IEmployeeServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileId = _data["profileId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.serviceCategoryId = _data["serviceCategoryId"];
        }
    }

    static fromJS(data: any): EmployeeServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileId"] = this.profileId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["serviceCategoryId"] = this.serviceCategoryId;
        return data;
    }
}

export interface IEmployeeServiceData {
    id?: number;
    profileId?: number;
    serviceId?: number;
    serviceName?: string | undefined;
    serviceCategoryId?: number;
}

export class HolidayData implements IHolidayData {
    id?: number;
    name?: string | undefined;
    date?: Date;
    dateTo?: Date | undefined;

    constructor(data?: IHolidayData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HolidayData {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHolidayData {
    id?: number;
    name?: string | undefined;
    date?: Date;
    dateTo?: Date | undefined;
}

export class HolidayDataPaginationData implements IHolidayDataPaginationData {
    items?: HolidayData[] | undefined;
    totalCount?: number;

    constructor(data?: IHolidayDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HolidayData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HolidayDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IHolidayDataPaginationData {
    items?: HolidayData[] | undefined;
    totalCount?: number;
}

export class HolidayDataPaginationDataAdministrationResult implements IHolidayDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: HolidayDataPaginationData;

    constructor(data?: IHolidayDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? HolidayDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HolidayDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHolidayDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: HolidayDataPaginationData;
}

export class Int32SecurityResult implements IInt32SecurityResult {
    status?: SecurityResultStatus;
    content?: number;

    constructor(data?: IInt32SecurityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): Int32SecurityResult {
        data = typeof data === 'object' ? data : {};
        let result = new Int32SecurityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content;
        return data;
    }
}

export interface IInt32SecurityResult {
    status?: SecurityResultStatus;
    content?: number;
}

export class LoginRequestData implements ILoginRequestData {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginRequestData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequestData {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequestData {
    username?: string | undefined;
    password?: string | undefined;
}

export class LoginUserData implements ILoginUserData {
    name?: string | undefined;
    surname?: string | undefined;
    accessToken?: string | undefined;
    accessTokenValidTo?: Date;
    shouldChangePassword?: boolean;

    constructor(data?: ILoginUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.accessToken = _data["accessToken"];
            this.accessTokenValidTo = _data["accessTokenValidTo"] ? new Date(_data["accessTokenValidTo"].toString()) : <any>undefined;
            this.shouldChangePassword = _data["shouldChangePassword"];
        }
    }

    static fromJS(data: any): LoginUserData {
        data = typeof data === 'object' ? data : {};
        let result = new LoginUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["accessToken"] = this.accessToken;
        data["accessTokenValidTo"] = this.accessTokenValidTo ? this.accessTokenValidTo.toISOString() : <any>undefined;
        data["shouldChangePassword"] = this.shouldChangePassword;
        return data;
    }
}

export interface ILoginUserData {
    name?: string | undefined;
    surname?: string | undefined;
    accessToken?: string | undefined;
    accessTokenValidTo?: Date;
    shouldChangePassword?: boolean;
}

export class LoginUserDataSecurityResult implements ILoginUserDataSecurityResult {
    status?: SecurityResultStatus;
    content?: LoginUserData;

    constructor(data?: ILoginUserDataSecurityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? LoginUserData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginUserDataSecurityResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoginUserDataSecurityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginUserDataSecurityResult {
    status?: SecurityResultStatus;
    content?: LoginUserData;
}

export class MembershipData implements IMembershipData {
    id?: number;
    credits?: number;
    fromDate?: Date;
    toDate?: Date | undefined;
    timeIns?: Date | undefined;
    membershipTypeId?: number;
    profileId?: number;
    membershipTypeName?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;

    constructor(data?: IMembershipData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.credits = _data["credits"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.timeIns = _data["timeIns"] ? new Date(_data["timeIns"].toString()) : <any>undefined;
            this.membershipTypeId = _data["membershipTypeId"];
            this.profileId = _data["profileId"];
            this.membershipTypeName = _data["membershipTypeName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): MembershipData {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["credits"] = this.credits;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["timeIns"] = this.timeIns ? this.timeIns.toISOString() : <any>undefined;
        data["membershipTypeId"] = this.membershipTypeId;
        data["profileId"] = this.profileId;
        data["membershipTypeName"] = this.membershipTypeName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IMembershipData {
    id?: number;
    credits?: number;
    fromDate?: Date;
    toDate?: Date | undefined;
    timeIns?: Date | undefined;
    membershipTypeId?: number;
    profileId?: number;
    membershipTypeName?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
}

export class MembershipDataAdministrationResult implements IMembershipDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipData;

    constructor(data?: IMembershipDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? MembershipData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembershipDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipData;
}

export class MembershipDataPaginationData implements IMembershipDataPaginationData {
    items?: MembershipData[] | undefined;
    totalCount?: number;

    constructor(data?: IMembershipDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MembershipData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MembershipDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IMembershipDataPaginationData {
    items?: MembershipData[] | undefined;
    totalCount?: number;
}

export class MembershipDataPaginationDataAdministrationResult implements IMembershipDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipDataPaginationData;

    constructor(data?: IMembershipDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? MembershipDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembershipDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipDataPaginationData;
}

export class MembershipTypeData implements IMembershipTypeData {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    credits?: number;
    price?: number;
    active?: boolean;

    constructor(data?: IMembershipTypeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.credits = _data["credits"];
            this.price = _data["price"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): MembershipTypeData {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["credits"] = this.credits;
        data["price"] = this.price;
        data["active"] = this.active;
        return data;
    }
}

export interface IMembershipTypeData {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    credits?: number;
    price?: number;
    active?: boolean;
}

export class MembershipTypeDataAdministrationResult implements IMembershipTypeDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipTypeData;

    constructor(data?: IMembershipTypeDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? MembershipTypeData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipTypeDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypeDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembershipTypeDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipTypeData;
}

export class MembershipTypeDataPaginationData implements IMembershipTypeDataPaginationData {
    items?: MembershipTypeData[] | undefined;
    totalCount?: number;

    constructor(data?: IMembershipTypeDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MembershipTypeData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MembershipTypeDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypeDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IMembershipTypeDataPaginationData {
    items?: MembershipTypeData[] | undefined;
    totalCount?: number;
}

export class MembershipTypeDataPaginationDataAdministrationResult implements IMembershipTypeDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipTypeDataPaginationData;

    constructor(data?: IMembershipTypeDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? MembershipTypeDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipTypeDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypeDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembershipTypeDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: MembershipTypeDataPaginationData;
}

export class PaginationArgs implements IPaginationArgs {
    skipCount?: number;
    maxResultCount?: number;
    sorting?: string | undefined;
    searchParam?: string | undefined;
    selectionId?: number | undefined;
    selectionId2?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IPaginationArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
            this.sorting = _data["sorting"];
            this.searchParam = _data["searchParam"];
            this.selectionId = _data["selectionId"];
            this.selectionId2 = _data["selectionId2"];
            this.active = _data["active"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginationArgs {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["sorting"] = this.sorting;
        data["searchParam"] = this.searchParam;
        data["selectionId"] = this.selectionId;
        data["selectionId2"] = this.selectionId2;
        data["active"] = this.active;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPaginationArgs {
    skipCount?: number;
    maxResultCount?: number;
    sorting?: string | undefined;
    searchParam?: string | undefined;
    selectionId?: number | undefined;
    selectionId2?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class PeriodicScheduleEntriesResultData implements IPeriodicScheduleEntriesResultData {
    schedules?: ScheduleData[] | undefined;
    periodicScheduleEntryDateRanges?: PeriodicScheduleEntryDateRangeData[] | undefined;
    dateRangeType?: PreloadCyclicTypeEnum;
    startDate?: Date;
    endDate?: Date;
    firstRetrievedDate?: Date;
    lastRetrievedDate?: Date;
    recommendedUpcomingPreloadStartDate?: Date | undefined;
    periodLength?: number;
    preloadAmount?: number;

    constructor(data?: IPeriodicScheduleEntriesResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(ScheduleData.fromJS(item));
            }
            if (Array.isArray(_data["periodicScheduleEntryDateRanges"])) {
                this.periodicScheduleEntryDateRanges = [] as any;
                for (let item of _data["periodicScheduleEntryDateRanges"])
                    this.periodicScheduleEntryDateRanges!.push(PeriodicScheduleEntryDateRangeData.fromJS(item));
            }
            this.dateRangeType = _data["dateRangeType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.firstRetrievedDate = _data["firstRetrievedDate"] ? new Date(_data["firstRetrievedDate"].toString()) : <any>undefined;
            this.lastRetrievedDate = _data["lastRetrievedDate"] ? new Date(_data["lastRetrievedDate"].toString()) : <any>undefined;
            this.recommendedUpcomingPreloadStartDate = _data["recommendedUpcomingPreloadStartDate"] ? new Date(_data["recommendedUpcomingPreloadStartDate"].toString()) : <any>undefined;
            this.periodLength = _data["periodLength"];
            this.preloadAmount = _data["preloadAmount"];
        }
    }

    static fromJS(data: any): PeriodicScheduleEntriesResultData {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodicScheduleEntriesResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item.toJSON());
        }
        if (Array.isArray(this.periodicScheduleEntryDateRanges)) {
            data["periodicScheduleEntryDateRanges"] = [];
            for (let item of this.periodicScheduleEntryDateRanges)
                data["periodicScheduleEntryDateRanges"].push(item.toJSON());
        }
        data["dateRangeType"] = this.dateRangeType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["firstRetrievedDate"] = this.firstRetrievedDate ? this.firstRetrievedDate.toISOString() : <any>undefined;
        data["lastRetrievedDate"] = this.lastRetrievedDate ? this.lastRetrievedDate.toISOString() : <any>undefined;
        data["recommendedUpcomingPreloadStartDate"] = this.recommendedUpcomingPreloadStartDate ? this.recommendedUpcomingPreloadStartDate.toISOString() : <any>undefined;
        data["periodLength"] = this.periodLength;
        data["preloadAmount"] = this.preloadAmount;
        return data;
    }
}

export interface IPeriodicScheduleEntriesResultData {
    schedules?: ScheduleData[] | undefined;
    periodicScheduleEntryDateRanges?: PeriodicScheduleEntryDateRangeData[] | undefined;
    dateRangeType?: PreloadCyclicTypeEnum;
    startDate?: Date;
    endDate?: Date;
    firstRetrievedDate?: Date;
    lastRetrievedDate?: Date;
    recommendedUpcomingPreloadStartDate?: Date | undefined;
    periodLength?: number;
    preloadAmount?: number;
}

export class PeriodicScheduleEntriesResultDataAdministrationResult implements IPeriodicScheduleEntriesResultDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: PeriodicScheduleEntriesResultData;

    constructor(data?: IPeriodicScheduleEntriesResultDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? PeriodicScheduleEntriesResultData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodicScheduleEntriesResultDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodicScheduleEntriesResultDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPeriodicScheduleEntriesResultDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: PeriodicScheduleEntriesResultData;
}

export class PeriodicScheduleEntryData implements IPeriodicScheduleEntryData {
    startingFrom?: Date;
    endOn?: Date;
    employees?: EmployeeMinifiedData[] | undefined;

    constructor(data?: IPeriodicScheduleEntryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeMinifiedData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PeriodicScheduleEntryData {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodicScheduleEntryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPeriodicScheduleEntryData {
    startingFrom?: Date;
    endOn?: Date;
    employees?: EmployeeMinifiedData[] | undefined;
}

export class PeriodicScheduleEntryDateRangeData implements IPeriodicScheduleEntryDateRangeData {
    periodicScheduleEntries?: { [key: string]: PeriodicScheduleEntryData[]; } | undefined;
    startingFrom?: Date;
    endOn?: Date;
    minHourInRange?: Date;
    maxHourInRange?: Date;
    dateRangeType?: PreloadCyclicTypeEnum;

    constructor(data?: IPeriodicScheduleEntryDateRangeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["periodicScheduleEntries"]) {
                this.periodicScheduleEntries = {} as any;
                for (let key in _data["periodicScheduleEntries"]) {
                    if (_data["periodicScheduleEntries"].hasOwnProperty(key))
                        (<any>this.periodicScheduleEntries)![key] = _data["periodicScheduleEntries"][key] ? _data["periodicScheduleEntries"][key].map((i: any) => PeriodicScheduleEntryData.fromJS(i)) : <any>undefined;
                }
            }
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.minHourInRange = _data["minHourInRange"] ? new Date(_data["minHourInRange"].toString()) : <any>undefined;
            this.maxHourInRange = _data["maxHourInRange"] ? new Date(_data["maxHourInRange"].toString()) : <any>undefined;
            this.dateRangeType = _data["dateRangeType"];
        }
    }

    static fromJS(data: any): PeriodicScheduleEntryDateRangeData {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodicScheduleEntryDateRangeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.periodicScheduleEntries) {
            data["periodicScheduleEntries"] = {};
            for (let key in this.periodicScheduleEntries) {
                if (this.periodicScheduleEntries.hasOwnProperty(key))
                    (<any>data["periodicScheduleEntries"])[key] = (<any>this.periodicScheduleEntries)[key];
            }
        }
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["minHourInRange"] = this.minHourInRange ? this.minHourInRange.toISOString() : <any>undefined;
        data["maxHourInRange"] = this.maxHourInRange ? this.maxHourInRange.toISOString() : <any>undefined;
        data["dateRangeType"] = this.dateRangeType;
        return data;
    }
}

export interface IPeriodicScheduleEntryDateRangeData {
    periodicScheduleEntries?: { [key: string]: PeriodicScheduleEntryData[]; } | undefined;
    startingFrom?: Date;
    endOn?: Date;
    minHourInRange?: Date;
    maxHourInRange?: Date;
    dateRangeType?: PreloadCyclicTypeEnum;
}

export class PeriodicScheduleGroupsAvailabilityArgs implements IPeriodicScheduleGroupsAvailabilityArgs {
    startDate?: Date;
    endDate?: Date | undefined;
    preloadAmount?: number | undefined;
    preloadCyclicType?: PreloadCyclicTypeEnum;
    employeeProfileId?: number | undefined;
    onlyActiveSchedules?: boolean | undefined;
    includeFullScheduleData?: boolean | undefined;

    constructor(data?: IPeriodicScheduleGroupsAvailabilityArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.preloadAmount = _data["preloadAmount"];
            this.preloadCyclicType = _data["preloadCyclicType"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.onlyActiveSchedules = _data["onlyActiveSchedules"];
            this.includeFullScheduleData = _data["includeFullScheduleData"];
        }
    }

    static fromJS(data: any): PeriodicScheduleGroupsAvailabilityArgs {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodicScheduleGroupsAvailabilityArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["preloadAmount"] = this.preloadAmount;
        data["preloadCyclicType"] = this.preloadCyclicType;
        data["employeeProfileId"] = this.employeeProfileId;
        data["onlyActiveSchedules"] = this.onlyActiveSchedules;
        data["includeFullScheduleData"] = this.includeFullScheduleData;
        return data;
    }
}

export interface IPeriodicScheduleGroupsAvailabilityArgs {
    startDate?: Date;
    endDate?: Date | undefined;
    preloadAmount?: number | undefined;
    preloadCyclicType?: PreloadCyclicTypeEnum;
    employeeProfileId?: number | undefined;
    onlyActiveSchedules?: boolean | undefined;
    includeFullScheduleData?: boolean | undefined;
}

export class PreBookedTermData implements IPreBookedTermData {
    serviceId?: number | undefined;
    employeeProfileId?: number;
    fromDate?: Date;

    constructor(data?: IPreBookedTermData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PreBookedTermData {
        data = typeof data === 'object' ? data : {};
        let result = new PreBookedTermData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["employeeProfileId"] = this.employeeProfileId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPreBookedTermData {
    serviceId?: number | undefined;
    employeeProfileId?: number;
    fromDate?: Date;
}

export enum PreloadCyclicTypeEnum {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export class PriorityWorkDayConfigData implements IPriorityWorkDayConfigData {
    id?: number;
    employeeProfileId?: number;
    forDate?: Date;
    fromTime?: Date;
    toTime?: Date;
    active?: boolean;
    working?: boolean;
    name?: string | undefined;
    surname?: string | undefined;

    constructor(data?: IPriorityWorkDayConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.forDate = _data["forDate"] ? new Date(_data["forDate"].toString()) : <any>undefined;
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.working = _data["working"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): PriorityWorkDayConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityWorkDayConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeProfileId"] = this.employeeProfileId;
        data["forDate"] = this.forDate ? this.forDate.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["working"] = this.working;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IPriorityWorkDayConfigData {
    id?: number;
    employeeProfileId?: number;
    forDate?: Date;
    fromTime?: Date;
    toTime?: Date;
    active?: boolean;
    working?: boolean;
    name?: string | undefined;
    surname?: string | undefined;
}

export class PriorityWorkDayConfigDataListAdministrationResult implements IPriorityWorkDayConfigDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: PriorityWorkDayConfigData[] | undefined;

    constructor(data?: IPriorityWorkDayConfigDataListAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(PriorityWorkDayConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PriorityWorkDayConfigDataListAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityWorkDayConfigDataListAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPriorityWorkDayConfigDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: PriorityWorkDayConfigData[] | undefined;
}

export class ReplaceEmployeeData implements IReplaceEmployeeData {
    replacedEmployeeProfileId?: number;
    replacementEmployeeProfileId?: number;
    fromDate?: Date;
    toDate?: Date;

    constructor(data?: IReplaceEmployeeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.replacedEmployeeProfileId = _data["replacedEmployeeProfileId"];
            this.replacementEmployeeProfileId = _data["replacementEmployeeProfileId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReplaceEmployeeData {
        data = typeof data === 'object' ? data : {};
        let result = new ReplaceEmployeeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["replacedEmployeeProfileId"] = this.replacedEmployeeProfileId;
        data["replacementEmployeeProfileId"] = this.replacementEmployeeProfileId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReplaceEmployeeData {
    replacedEmployeeProfileId?: number;
    replacementEmployeeProfileId?: number;
    fromDate?: Date;
    toDate?: Date;
}

export class RetrieveGeneratedTimeSlotsData implements IRetrieveGeneratedTimeSlotsData {
    profileId?: number;
    serviceId?: number;
    dateTime?: Date | undefined;
    numberOfAppointments?: number;
    everyNDaysCount?: number | undefined;
    employeeProfileId?: number | undefined;
    daysList?: DayData[] | undefined;

    constructor(data?: IRetrieveGeneratedTimeSlotsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.serviceId = _data["serviceId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.numberOfAppointments = _data["numberOfAppointments"];
            this.everyNDaysCount = _data["everyNDaysCount"];
            this.employeeProfileId = _data["employeeProfileId"];
            if (Array.isArray(_data["daysList"])) {
                this.daysList = [] as any;
                for (let item of _data["daysList"])
                    this.daysList!.push(DayData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetrieveGeneratedTimeSlotsData {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveGeneratedTimeSlotsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["serviceId"] = this.serviceId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["numberOfAppointments"] = this.numberOfAppointments;
        data["everyNDaysCount"] = this.everyNDaysCount;
        data["employeeProfileId"] = this.employeeProfileId;
        if (Array.isArray(this.daysList)) {
            data["daysList"] = [];
            for (let item of this.daysList)
                data["daysList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetrieveGeneratedTimeSlotsData {
    profileId?: number;
    serviceId?: number;
    dateTime?: Date | undefined;
    numberOfAppointments?: number;
    everyNDaysCount?: number | undefined;
    employeeProfileId?: number | undefined;
    daysList?: DayData[] | undefined;
}

export class ScheduleData implements IScheduleData {
    id?: number;
    employeeProfileId?: number | undefined;
    startingFrom?: Date;
    endOn?: Date;
    active?: boolean;
    name?: string | undefined;
    surname?: string | undefined;
    shiftTemplateId?: number | undefined;
    workWeekConfigs?: WorkWeekConfigData[] | undefined;

    constructor(data?: IScheduleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.shiftTemplateId = _data["shiftTemplateId"];
            if (Array.isArray(_data["workWeekConfigs"])) {
                this.workWeekConfigs = [] as any;
                for (let item of _data["workWeekConfigs"])
                    this.workWeekConfigs!.push(WorkWeekConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleData {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeProfileId"] = this.employeeProfileId;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["shiftTemplateId"] = this.shiftTemplateId;
        if (Array.isArray(this.workWeekConfigs)) {
            data["workWeekConfigs"] = [];
            for (let item of this.workWeekConfigs)
                data["workWeekConfigs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScheduleData {
    id?: number;
    employeeProfileId?: number | undefined;
    startingFrom?: Date;
    endOn?: Date;
    active?: boolean;
    name?: string | undefined;
    surname?: string | undefined;
    shiftTemplateId?: number | undefined;
    workWeekConfigs?: WorkWeekConfigData[] | undefined;
}

export class ScheduleDataAdministrationResult implements IScheduleDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ScheduleData;

    constructor(data?: IScheduleDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ScheduleData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScheduleDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ScheduleData;
}

export class ScheduleDataListAdministrationResult implements IScheduleDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ScheduleData[] | undefined;

    constructor(data?: IScheduleDataListAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(ScheduleData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleDataListAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDataListAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScheduleDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ScheduleData[] | undefined;
}

export enum SecurityResultStatus {
    Success = "Success",
    ServerError = "ServerError",
    ArgumentsException = "ArgumentsException",
    NotFound = "NotFound",
    WrongCreditials = "WrongCreditials",
    UserNotValidated = "UserNotValidated",
    Error = "Error",
    NotAuthenticated = "NotAuthenticated",
    InvalidToken = "InvalidToken",
    TokenAlreadyRefreshed = "TokenAlreadyRefreshed",
    TokenExpired = "TokenExpired",
    SuccessWithRefresh = "SuccessWithRefresh",
    EmailNotVerified = "EmailNotVerified",
    EmailNotValidFormat = "EmailNotValidFormat",
    UserDisabled = "UserDisabled",
    InvalidUser = "InvalidUser",
    VerificationCodeExpired = "VerificationCodeExpired",
    VerificationCodeAlreadyUsed = "VerificationCodeAlreadyUsed",
    InvalidVerificationCode = "InvalidVerificationCode",
    AccessDenied = "AccessDenied",
}

export class ServiceCategoryData implements IServiceCategoryData {
    id?: number;
    name?: string | undefined;
    serviceTypeId?: number;
    requiresMembership?: boolean;
    active?: boolean;
    serviceTypeName?: string | undefined;
    image?: string | undefined;
    services?: ServiceData[] | undefined;

    constructor(data?: IServiceCategoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.requiresMembership = _data["requiresMembership"];
            this.active = _data["active"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.image = _data["image"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceCategoryData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCategoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["serviceTypeId"] = this.serviceTypeId;
        data["requiresMembership"] = this.requiresMembership;
        data["active"] = this.active;
        data["serviceTypeName"] = this.serviceTypeName;
        data["image"] = this.image;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceCategoryData {
    id?: number;
    name?: string | undefined;
    serviceTypeId?: number;
    requiresMembership?: boolean;
    active?: boolean;
    serviceTypeName?: string | undefined;
    image?: string | undefined;
    services?: ServiceData[] | undefined;
}

export class ServiceCategoryDataAdministrationResult implements IServiceCategoryDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceCategoryData;

    constructor(data?: IServiceCategoryDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceCategoryData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceCategoryDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCategoryDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceCategoryDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceCategoryData;
}

export class ServiceCategoryDataPaginationData implements IServiceCategoryDataPaginationData {
    items?: ServiceCategoryData[] | undefined;
    totalCount?: number;

    constructor(data?: IServiceCategoryDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCategoryData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceCategoryDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCategoryDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IServiceCategoryDataPaginationData {
    items?: ServiceCategoryData[] | undefined;
    totalCount?: number;
}

export class ServiceCategoryDataPaginationDataAdministrationResult implements IServiceCategoryDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceCategoryDataPaginationData;

    constructor(data?: IServiceCategoryDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceCategoryDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceCategoryDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCategoryDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceCategoryDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceCategoryDataPaginationData;
}

export class ServiceData implements IServiceData {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    price?: number;
    duration?: number | undefined;
    serviceCategoryId?: number;
    credits?: number;
    active?: boolean;
    serviceCategoryName?: string | undefined;
    serviceTypeName?: string | undefined;

    constructor(data?: IServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.duration = _data["duration"];
            this.serviceCategoryId = _data["serviceCategoryId"];
            this.credits = _data["credits"];
            this.active = _data["active"];
            this.serviceCategoryName = _data["serviceCategoryName"];
            this.serviceTypeName = _data["serviceTypeName"];
        }
    }

    static fromJS(data: any): ServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["duration"] = this.duration;
        data["serviceCategoryId"] = this.serviceCategoryId;
        data["credits"] = this.credits;
        data["active"] = this.active;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeName"] = this.serviceTypeName;
        return data;
    }
}

export interface IServiceData {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    price?: number;
    duration?: number | undefined;
    serviceCategoryId?: number;
    credits?: number;
    active?: boolean;
    serviceCategoryName?: string | undefined;
    serviceTypeName?: string | undefined;
}

export class ServiceDataAdministrationResult implements IServiceDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceData;

    constructor(data?: IServiceDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceData;
}

export class ServiceDataPaginationData implements IServiceDataPaginationData {
    items?: ServiceData[] | undefined;
    totalCount?: number;

    constructor(data?: IServiceDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IServiceDataPaginationData {
    items?: ServiceData[] | undefined;
    totalCount?: number;
}

export class ServiceDataPaginationDataAdministrationResult implements IServiceDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceDataPaginationData;

    constructor(data?: IServiceDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceDataPaginationData;
}

export class ServiceDiscountData implements IServiceDiscountData {
    id?: number;
    serviceId?: number;
    percentage?: number;
    discountedPrice?: number;
    fromDate?: Date;
    toDate?: Date;

    constructor(data?: IServiceDiscountData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.percentage = _data["percentage"];
            this.discountedPrice = _data["discountedPrice"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDiscountData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDiscountData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["percentage"] = this.percentage;
        data["discountedPrice"] = this.discountedPrice;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceDiscountData {
    id?: number;
    serviceId?: number;
    percentage?: number;
    discountedPrice?: number;
    fromDate?: Date;
    toDate?: Date;
}

export class ServiceDiscountDataAdministrationResult implements IServiceDiscountDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceDiscountData;

    constructor(data?: IServiceDiscountDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceDiscountData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDiscountDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDiscountDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceDiscountDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceDiscountData;
}

export class ServiceDiscountDataPaginationData implements IServiceDiscountDataPaginationData {
    items?: ServiceDiscountData[] | undefined;
    totalCount?: number;

    constructor(data?: IServiceDiscountDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceDiscountData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceDiscountDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDiscountDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IServiceDiscountDataPaginationData {
    items?: ServiceDiscountData[] | undefined;
    totalCount?: number;
}

export class ServiceDiscountDataPaginationDataAdministrationResult implements IServiceDiscountDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceDiscountDataPaginationData;

    constructor(data?: IServiceDiscountDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceDiscountDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDiscountDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDiscountDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceDiscountDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceDiscountDataPaginationData;
}

export class ServiceTypeData implements IServiceTypeData {
    id?: number;
    name?: string | undefined;
    freeCancellingHours?: number;
    maxClientsPerTerm?: number;

    constructor(data?: IServiceTypeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.freeCancellingHours = _data["freeCancellingHours"];
            this.maxClientsPerTerm = _data["maxClientsPerTerm"];
        }
    }

    static fromJS(data: any): ServiceTypeData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["freeCancellingHours"] = this.freeCancellingHours;
        data["maxClientsPerTerm"] = this.maxClientsPerTerm;
        return data;
    }
}

export interface IServiceTypeData {
    id?: number;
    name?: string | undefined;
    freeCancellingHours?: number;
    maxClientsPerTerm?: number;
}

export class ServiceTypeDataAdministrationResult implements IServiceTypeDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceTypeData;

    constructor(data?: IServiceTypeDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceTypeData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceTypeDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceTypeDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceTypeData;
}

export class ServiceTypeDataPaginationData implements IServiceTypeDataPaginationData {
    items?: ServiceTypeData[] | undefined;
    totalCount?: number;

    constructor(data?: IServiceTypeDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceTypeData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceTypeDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IServiceTypeDataPaginationData {
    items?: ServiceTypeData[] | undefined;
    totalCount?: number;
}

export class ServiceTypeDataPaginationDataAdministrationResult implements IServiceTypeDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceTypeDataPaginationData;

    constructor(data?: IServiceTypeDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ServiceTypeDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceTypeDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceTypeDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ServiceTypeDataPaginationData;
}

export class ShiftTemplateData implements IShiftTemplateData {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    scheduleId?: number;
    startingFrom?: Date;
    endOn?: Date;
    repeating?: boolean;
    workWeekList?: WorkWeekConfigData[] | undefined;

    constructor(data?: IShiftTemplateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.scheduleId = _data["scheduleId"];
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.repeating = _data["repeating"];
            if (Array.isArray(_data["workWeekList"])) {
                this.workWeekList = [] as any;
                for (let item of _data["workWeekList"])
                    this.workWeekList!.push(WorkWeekConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftTemplateData {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftTemplateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["scheduleId"] = this.scheduleId;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["repeating"] = this.repeating;
        if (Array.isArray(this.workWeekList)) {
            data["workWeekList"] = [];
            for (let item of this.workWeekList)
                data["workWeekList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShiftTemplateData {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    scheduleId?: number;
    startingFrom?: Date;
    endOn?: Date;
    repeating?: boolean;
    workWeekList?: WorkWeekConfigData[] | undefined;
}

export class ShiftTemplateDataAdministrationResult implements IShiftTemplateDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ShiftTemplateData;

    constructor(data?: IShiftTemplateDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? ShiftTemplateData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShiftTemplateDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftTemplateDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShiftTemplateDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ShiftTemplateData;
}

export class ShiftTemplateDataListAdministrationResult implements IShiftTemplateDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ShiftTemplateData[] | undefined;

    constructor(data?: IShiftTemplateDataListAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(ShiftTemplateData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftTemplateDataListAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftTemplateDataListAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShiftTemplateDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: ShiftTemplateData[] | undefined;
}

export class TermData implements ITermData {
    id?: number;
    profileId?: number | undefined;
    bookingId?: number | undefined;
    serviceId?: number;
    fromDate?: Date;
    toDate?: Date;
    bookedOn?: Date | undefined;
    cancelled?: boolean;
    rescheduledTermId?: number | undefined;
    recurringTermGroupId?: number | undefined;
    employeeProfileId?: number;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    anonymousEmail?: string | undefined;
    employeeName?: string | undefined;
    employeeSurname?: string | undefined;
    email?: string | undefined;
    serviceName?: string | undefined;
    servicePrice?: number;
    serviceDuration?: number;
    unavailableTerm?: boolean | undefined;
    unavailableEmployee?: boolean | undefined;
    editAllRecurring?: boolean | undefined;
    viewed?: boolean | undefined;
    booked?: boolean | undefined;
    alternativeTermDataList?: TermData[] | undefined;

    constructor(data?: ITermData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileId = _data["profileId"];
            this.bookingId = _data["bookingId"];
            this.serviceId = _data["serviceId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.bookedOn = _data["bookedOn"] ? new Date(_data["bookedOn"].toString()) : <any>undefined;
            this.cancelled = _data["cancelled"];
            this.rescheduledTermId = _data["rescheduledTermId"];
            this.recurringTermGroupId = _data["recurringTermGroupId"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.anonymousEmail = _data["anonymousEmail"];
            this.employeeName = _data["employeeName"];
            this.employeeSurname = _data["employeeSurname"];
            this.email = _data["email"];
            this.serviceName = _data["serviceName"];
            this.servicePrice = _data["servicePrice"];
            this.serviceDuration = _data["serviceDuration"];
            this.unavailableTerm = _data["unavailableTerm"];
            this.unavailableEmployee = _data["unavailableEmployee"];
            this.editAllRecurring = _data["editAllRecurring"];
            this.viewed = _data["viewed"];
            this.booked = _data["booked"];
            if (Array.isArray(_data["alternativeTermDataList"])) {
                this.alternativeTermDataList = [] as any;
                for (let item of _data["alternativeTermDataList"])
                    this.alternativeTermDataList!.push(TermData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TermData {
        data = typeof data === 'object' ? data : {};
        let result = new TermData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileId"] = this.profileId;
        data["bookingId"] = this.bookingId;
        data["serviceId"] = this.serviceId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["bookedOn"] = this.bookedOn ? this.bookedOn.toISOString() : <any>undefined;
        data["cancelled"] = this.cancelled;
        data["rescheduledTermId"] = this.rescheduledTermId;
        data["recurringTermGroupId"] = this.recurringTermGroupId;
        data["employeeProfileId"] = this.employeeProfileId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["anonymousEmail"] = this.anonymousEmail;
        data["employeeName"] = this.employeeName;
        data["employeeSurname"] = this.employeeSurname;
        data["email"] = this.email;
        data["serviceName"] = this.serviceName;
        data["servicePrice"] = this.servicePrice;
        data["serviceDuration"] = this.serviceDuration;
        data["unavailableTerm"] = this.unavailableTerm;
        data["unavailableEmployee"] = this.unavailableEmployee;
        data["editAllRecurring"] = this.editAllRecurring;
        data["viewed"] = this.viewed;
        data["booked"] = this.booked;
        if (Array.isArray(this.alternativeTermDataList)) {
            data["alternativeTermDataList"] = [];
            for (let item of this.alternativeTermDataList)
                data["alternativeTermDataList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITermData {
    id?: number;
    profileId?: number | undefined;
    bookingId?: number | undefined;
    serviceId?: number;
    fromDate?: Date;
    toDate?: Date;
    bookedOn?: Date | undefined;
    cancelled?: boolean;
    rescheduledTermId?: number | undefined;
    recurringTermGroupId?: number | undefined;
    employeeProfileId?: number;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    anonymousEmail?: string | undefined;
    employeeName?: string | undefined;
    employeeSurname?: string | undefined;
    email?: string | undefined;
    serviceName?: string | undefined;
    servicePrice?: number;
    serviceDuration?: number;
    unavailableTerm?: boolean | undefined;
    unavailableEmployee?: boolean | undefined;
    editAllRecurring?: boolean | undefined;
    viewed?: boolean | undefined;
    booked?: boolean | undefined;
    alternativeTermDataList?: TermData[] | undefined;
}

export class TermDataAdministrationResult implements ITermDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: TermData;

    constructor(data?: ITermDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? TermData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TermDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TermDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITermDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: TermData;
}

export class TermDataListAdministrationResult implements ITermDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: TermData[] | undefined;

    constructor(data?: ITermDataListAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(TermData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TermDataListAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TermDataListAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITermDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: TermData[] | undefined;
}

export class TermDataPaginationData implements ITermDataPaginationData {
    items?: TermData[] | undefined;
    totalCount?: number;

    constructor(data?: ITermDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TermData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TermDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new TermDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ITermDataPaginationData {
    items?: TermData[] | undefined;
    totalCount?: number;
}

export class TermDataPaginationDataAdministrationResult implements ITermDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: TermDataPaginationData;

    constructor(data?: ITermDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? TermDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TermDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TermDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITermDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: TermDataPaginationData;
}

export class TermSearchArgs implements ITermSearchArgs {
    employeeProfileId?: number | undefined;
    serviceId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    fromTime?: Date | undefined;
    toTime?: Date | undefined;
    includeCancelled?: boolean | undefined;
    includePassedTerms?: boolean | undefined;

    constructor(data?: ITermSearchArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeProfileId = _data["employeeProfileId"];
            this.serviceId = _data["serviceId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.includeCancelled = _data["includeCancelled"];
            this.includePassedTerms = _data["includePassedTerms"];
        }
    }

    static fromJS(data: any): TermSearchArgs {
        data = typeof data === 'object' ? data : {};
        let result = new TermSearchArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeProfileId"] = this.employeeProfileId;
        data["serviceId"] = this.serviceId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["includeCancelled"] = this.includeCancelled;
        data["includePassedTerms"] = this.includePassedTerms;
        return data;
    }
}

export interface ITermSearchArgs {
    employeeProfileId?: number | undefined;
    serviceId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    fromTime?: Date | undefined;
    toTime?: Date | undefined;
    includeCancelled?: boolean | undefined;
    includePassedTerms?: boolean | undefined;
}

export class UpdateConfigurationData implements IUpdateConfigurationData {
    id?: number;
    possibleNegativeCredits?: number | undefined;
    timeBetweenGeneratedTermsInMinutes?: number | undefined;
    pauseTimeAfterTermsInMinutes?: number | undefined;
    active?: boolean | undefined;
    workingHours?: AddWorkingHoursDailyConfigs;

    constructor(data?: IUpdateConfigurationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.possibleNegativeCredits = _data["possibleNegativeCredits"];
            this.timeBetweenGeneratedTermsInMinutes = _data["timeBetweenGeneratedTermsInMinutes"];
            this.pauseTimeAfterTermsInMinutes = _data["pauseTimeAfterTermsInMinutes"];
            this.active = _data["active"];
            this.workingHours = _data["workingHours"] ? AddWorkingHoursDailyConfigs.fromJS(_data["workingHours"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateConfigurationData {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigurationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["possibleNegativeCredits"] = this.possibleNegativeCredits;
        data["timeBetweenGeneratedTermsInMinutes"] = this.timeBetweenGeneratedTermsInMinutes;
        data["pauseTimeAfterTermsInMinutes"] = this.pauseTimeAfterTermsInMinutes;
        data["active"] = this.active;
        data["workingHours"] = this.workingHours ? this.workingHours.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateConfigurationData {
    id?: number;
    possibleNegativeCredits?: number | undefined;
    timeBetweenGeneratedTermsInMinutes?: number | undefined;
    pauseTimeAfterTermsInMinutes?: number | undefined;
    active?: boolean | undefined;
    workingHours?: AddWorkingHoursDailyConfigs;
}

export class UpdateScheduleData implements IUpdateScheduleData {
    scheduleId?: number;
    employeeProfileId?: number;
    startingFrom?: Date;
    endOn?: Date;
    workWeekList?: UpdateWorkWeekConfigData[] | undefined;

    constructor(data?: IUpdateScheduleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleId = _data["scheduleId"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["workWeekList"])) {
                this.workWeekList = [] as any;
                for (let item of _data["workWeekList"])
                    this.workWeekList!.push(UpdateWorkWeekConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateScheduleData {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleId"] = this.scheduleId;
        data["employeeProfileId"] = this.employeeProfileId;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        if (Array.isArray(this.workWeekList)) {
            data["workWeekList"] = [];
            for (let item of this.workWeekList)
                data["workWeekList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateScheduleData {
    scheduleId?: number;
    employeeProfileId?: number;
    startingFrom?: Date;
    endOn?: Date;
    workWeekList?: UpdateWorkWeekConfigData[] | undefined;
}

export class UpdateShiftTemplateData implements IUpdateShiftTemplateData {
    scheduleId?: number;
    name?: string | undefined;
    description?: string | undefined;
    startingFrom?: Date;
    endOn?: Date;
    repeating?: boolean;
    workWeekList?: AddWorkWeekConfigData[] | undefined;

    constructor(data?: IUpdateShiftTemplateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleId = _data["scheduleId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.repeating = _data["repeating"];
            if (Array.isArray(_data["workWeekList"])) {
                this.workWeekList = [] as any;
                for (let item of _data["workWeekList"])
                    this.workWeekList!.push(AddWorkWeekConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateShiftTemplateData {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShiftTemplateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleId"] = this.scheduleId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["repeating"] = this.repeating;
        if (Array.isArray(this.workWeekList)) {
            data["workWeekList"] = [];
            for (let item of this.workWeekList)
                data["workWeekList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateShiftTemplateData {
    scheduleId?: number;
    name?: string | undefined;
    description?: string | undefined;
    startingFrom?: Date;
    endOn?: Date;
    repeating?: boolean;
    workWeekList?: AddWorkWeekConfigData[] | undefined;
}

export class UpdateWorkDayConfigData implements IUpdateWorkDayConfigData {
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean | undefined;

    constructor(data?: IUpdateWorkDayConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.working = _data["working"];
        }
    }

    static fromJS(data: any): UpdateWorkDayConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkDayConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["working"] = this.working;
        return data;
    }
}

export interface IUpdateWorkDayConfigData {
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean | undefined;
}

export class UpdateWorkWeekConfigData implements IUpdateWorkWeekConfigData {
    workDaysConfig?: UpdateWorkDayConfigData[] | undefined;

    constructor(data?: IUpdateWorkWeekConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workDaysConfig"])) {
                this.workDaysConfig = [] as any;
                for (let item of _data["workDaysConfig"])
                    this.workDaysConfig!.push(UpdateWorkDayConfigData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateWorkWeekConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkWeekConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workDaysConfig)) {
            data["workDaysConfig"] = [];
            for (let item of this.workDaysConfig)
                data["workDaysConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateWorkWeekConfigData {
    workDaysConfig?: UpdateWorkDayConfigData[] | undefined;
}

export class UserProfileData implements IUserProfileData {
    id?: number;
    username?: string | undefined;
    password?: string | undefined;
    roleId?: number | undefined;
    roleName?: string | undefined;
    isTemporaryPassword?: boolean | undefined;
    email?: string | undefined;
    active?: boolean;
    verificationCodeId?: number | undefined;
    profileId?: number;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    anonymousEmail?: string | undefined;
    employeeServicesList?: EmployeeServiceData[] | undefined;

    constructor(data?: IUserProfileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isTemporaryPassword = _data["isTemporaryPassword"];
            this.email = _data["email"];
            this.active = _data["active"];
            this.verificationCodeId = _data["verificationCodeId"];
            this.profileId = _data["profileId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.anonymousEmail = _data["anonymousEmail"];
            if (Array.isArray(_data["employeeServicesList"])) {
                this.employeeServicesList = [] as any;
                for (let item of _data["employeeServicesList"])
                    this.employeeServicesList!.push(EmployeeServiceData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserProfileData {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["password"] = this.password;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isTemporaryPassword"] = this.isTemporaryPassword;
        data["email"] = this.email;
        data["active"] = this.active;
        data["verificationCodeId"] = this.verificationCodeId;
        data["profileId"] = this.profileId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["anonymousEmail"] = this.anonymousEmail;
        if (Array.isArray(this.employeeServicesList)) {
            data["employeeServicesList"] = [];
            for (let item of this.employeeServicesList)
                data["employeeServicesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserProfileData {
    id?: number;
    username?: string | undefined;
    password?: string | undefined;
    roleId?: number | undefined;
    roleName?: string | undefined;
    isTemporaryPassword?: boolean | undefined;
    email?: string | undefined;
    active?: boolean;
    verificationCodeId?: number | undefined;
    profileId?: number;
    name?: string | undefined;
    surname?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    anonymousEmail?: string | undefined;
    employeeServicesList?: EmployeeServiceData[] | undefined;
}

export class UserProfileDataAdministrationResult implements IUserProfileDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserProfileData;

    constructor(data?: IUserProfileDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? UserProfileData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserProfileDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserProfileDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserProfileData;
}

export class UserProfileDataPaginationData implements IUserProfileDataPaginationData {
    items?: UserProfileData[] | undefined;
    totalCount?: number;

    constructor(data?: IUserProfileDataPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserProfileData.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserProfileDataPaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDataPaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IUserProfileDataPaginationData {
    items?: UserProfileData[] | undefined;
    totalCount?: number;
}

export class UserProfileDataPaginationDataAdministrationResult implements IUserProfileDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserProfileDataPaginationData;

    constructor(data?: IUserProfileDataPaginationDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? UserProfileDataPaginationData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserProfileDataPaginationDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDataPaginationDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserProfileDataPaginationDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserProfileDataPaginationData;
}

export class UserRoleData implements IUserRoleData {
    id?: number;
    username?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserRoleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.password = _data["password"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserRoleData {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["password"] = this.password;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserRoleData {
    id?: number;
    username?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
}

export class UserRoleDataAdministrationResult implements IUserRoleDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserRoleData;

    constructor(data?: IUserRoleDataAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.content = _data["content"] ? UserRoleData.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRoleDataAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDataAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserRoleDataAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserRoleData;
}

export class UserRoleDataListAdministrationResult implements IUserRoleDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserRoleData[] | undefined;

    constructor(data?: IUserRoleDataListAdministrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(UserRoleData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserRoleDataListAdministrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDataListAdministrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserRoleDataListAdministrationResult {
    status?: AdministrationResultStatus;
    content?: UserRoleData[] | undefined;
}

export class WorkDayConfigAvailabilityData implements IWorkDayConfigAvailabilityData {
    workDayConfigId?: number;
    weekId?: number | undefined;
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;

    constructor(data?: IWorkDayConfigAvailabilityData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workDayConfigId = _data["workDayConfigId"];
            this.weekId = _data["weekId"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.working = _data["working"];
        }
    }

    static fromJS(data: any): WorkDayConfigAvailabilityData {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDayConfigAvailabilityData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workDayConfigId"] = this.workDayConfigId;
        data["weekId"] = this.weekId;
        data["dayOfWeek"] = this.dayOfWeek;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["working"] = this.working;
        return data;
    }
}

export interface IWorkDayConfigAvailabilityData {
    workDayConfigId?: number;
    weekId?: number | undefined;
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;
}

export class WorkDayConfigData implements IWorkDayConfigData {
    id?: number;
    weekId?: number;
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;

    constructor(data?: IWorkDayConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weekId = _data["weekId"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.working = _data["working"];
        }
    }

    static fromJS(data: any): WorkDayConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDayConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekId"] = this.weekId;
        data["dayOfWeek"] = this.dayOfWeek;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["working"] = this.working;
        return data;
    }
}

export interface IWorkDayConfigData {
    id?: number;
    weekId?: number;
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;
}

export class WorkWeekConfigData implements IWorkWeekConfigData {
    id?: number;
    scheduleId?: number;
    startingFrom?: Date;
    workDaysConfig?: { [key: string]: WorkDayConfigData[]; } | undefined;

    constructor(data?: IWorkWeekConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduleId = _data["scheduleId"];
            this.startingFrom = _data["startingFrom"] ? new Date(_data["startingFrom"].toString()) : <any>undefined;
            if (_data["workDaysConfig"]) {
                this.workDaysConfig = {} as any;
                for (let key in _data["workDaysConfig"]) {
                    if (_data["workDaysConfig"].hasOwnProperty(key))
                        (<any>this.workDaysConfig)![key] = _data["workDaysConfig"][key] ? _data["workDaysConfig"][key].map((i: any) => WorkDayConfigData.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): WorkWeekConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new WorkWeekConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduleId"] = this.scheduleId;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toISOString() : <any>undefined;
        if (this.workDaysConfig) {
            data["workDaysConfig"] = {};
            for (let key in this.workDaysConfig) {
                if (this.workDaysConfig.hasOwnProperty(key))
                    (<any>data["workDaysConfig"])[key] = (<any>this.workDaysConfig)[key];
            }
        }
        return data;
    }
}

export interface IWorkWeekConfigData {
    id?: number;
    scheduleId?: number;
    startingFrom?: Date;
    workDaysConfig?: { [key: string]: WorkDayConfigData[]; } | undefined;
}

export class WorkingHoursDailyConfigData implements IWorkingHoursDailyConfigData {
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;

    constructor(data?: IWorkingHoursDailyConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.fromTime = _data["fromTime"] ? new Date(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? new Date(_data["toTime"].toString()) : <any>undefined;
            this.working = _data["working"];
        }
    }

    static fromJS(data: any): WorkingHoursDailyConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingHoursDailyConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["working"] = this.working;
        return data;
    }
}

export interface IWorkingHoursDailyConfigData {
    dayOfWeek?: number;
    fromTime?: Date;
    toTime?: Date;
    working?: boolean;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}